import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useIdioma } from '../../context/IdiomaContext';
import { getProductosCatalogoTienda, getProductosCatalogo } from '../../services/productosApi';
import { obtenerCategoriasTienda, obtenerCategorias } from '../../services/categoriasServicio';
import { obtenerConfiguracionTienda } from '../../services/configTiendaApi';
import { registrarPedidoWeb, registrarPedidoMesaPublico, consultarEstadoPedido, enviarCodigoValidacion, verificarCodigoValidacion, verificarTelefonoValidado, solicitarCuentaMesa, consultarCuentaMesa } from '../../services/pedidosServicio';
import config, { resolveImagenUrl } from '../../config/apiConfig';
import CatalogoLista from './CatalogoLista';
import CatalogoCategorias from './CatalogoCategorias';
import SelectorVariantesModal from '../Generales/SelectorVariantes';
import { GoogleMap, useJsApiLoader, Autocomplete, Marker, Polygon } from '@react-google-maps/api';
import config_ from '../../config/appConfig';
import MapaErrorBoundary from '../Generales/MapaErrorBoundary';
import { obtenerEstilosTienda, aplicarEstilos } from '../../services/themeService';

// 🚩 Mismo id ('google-map-script') que TPV.js y AdministradorDespachos.js,
// así que TIENE que tener exactamente el mismo array de libraries en los tres
// — si no, @react-google-maps/api revienta con "Loader must not be called
// again with different options" al navegar de una pantalla a otra sin
// recargar la página completa (SPA routing).
// 🚩 'drawing' se sacó: Google eliminó DrawingManager de la API (removido may-2026).
const libraries = ['places', 'geometry'];

const prepararTelefonoChile = (tel) => {
    if (!tel) return "";
    let limpio = tel.replace(/\D/g, '');
    if (limpio.length === 9) return "+56" + limpio;
    if (limpio.length === 11 && limpio.startsWith('56')) return "+" + limpio;
    if (limpio.startsWith('569')) return "+" + limpio;
    return tel.startsWith('+') ? tel : "+" + limpio;
};

// Traduce un array de strings usando MyMemory (gratis, sin API key)
async function traducirTexto(texto, langTarget) {
    if (!texto) return texto;
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=es&tl=${langTarget}&dt=t&q=${encodeURIComponent(texto)}`;
    try {
        const res = await fetch(url);
        const data = await res.json();
        return data[0].map(seg => seg[0]).join('');
    } catch (e) {
        return texto;
    }
}

async function traducirTextos(textos, langTarget) {
    if (langTarget === 'es') return textos;
    const LOTE = 6;
    const resultado = new Array(textos.length).fill('');
    for (let i = 0; i < textos.length; i += LOTE) {
        const lote = textos.slice(i, i + LOTE);
        const traducciones = await Promise.all(lote.map(t => traducirTexto(t, langTarget)));
        traducciones.forEach((t, j) => { resultado[i + j] = t; });
    }
    return resultado;
}

function Pedidos() {
    const { slug } = useParams();
    const location = useLocation();
    const { t, idioma, cambiarIdioma } = useIdioma();
    const [productosTraducidos, setProductosTraducidos] = useState([]);
    // Mapa  nombre original -> nombre traducido  para las categorias.
    // Se guarda como mapa y NO se reemplaza categoriasNombres porque el
    // nombre original es la llave con la que se filtran los productos
    // (ver perteneceACategoria y categoriaActiva). Traducir solo lo que se
    // muestra deja el filtrado intacto.
    const [traduccionCategorias, setTraduccionCategorias] = useState({});
    const [traduciendo, setTraduciendo] = useState(false);

    const queryParams = new URLSearchParams(location.search);
    // 🚩 Esquema de URLs:
    //   komity.cl/slug            → Tienda (pedidos delivery/retiro) — esModoTiendaWeb
    //   komity.cl/qr/slug         → Carta QR de solo lectura — esModoQR
    //   komity.cl/qr/slug?mesa_id → Pedido en mesa (a futuro: /qr/slug/:codigoMesa dinámico)
    //   /cli/:slug y /negocio/:slug se mantienen como alias viejos de /qr/:slug
    //   (links/QR ya impresos antes de este cambio).
    const esModoQR = location.pathname.startsWith('/negocio/') || location.pathname.startsWith('/cli/') || location.pathname.startsWith('/qr/') || queryParams.get('modo') === 'qr';
    const mesaId = queryParams.get('mesa_id'); // 🚩 Detectar mesa_id desde QR
    const esModoMesa = esModoQR && mesaId; // QR + mesa_id = modo pedido en mesa
    // 🚩 Tienda online: el link "normal" (bare /slug). Es la excepción real al
    // bloqueo de "pedidos web pausado" de abajo.
    const esModoTiendaWeb = location.pathname === `/${slug}`;
    // 🚩 Pedidos web (delivery/retiro) pausado por decision de negocio salvo en
    // /slug (tienda): todo queda de solo lectura salvo el pedido-desde-mesa via
    // QR (esModoMesa) o la tienda online (esModoTiendaWeb).
    // 🚩 El pedido activo se guarda por MODO, no por local. Antes habia una
    // sola llave `pedido_<slug>` compartida entre la tienda web, la carta QR y
    // el pedido de mesa: un pedido hecho en la tienda reaparecia como
    // seguimiento a pantalla completa al escanear el QR, tapando la carta.
    //   mesa                    -> pedido_<slug>_mesa_<mesaId>  (por mesa, no por local:
    //                              si el cliente se cambia de mesa no arrastra la anterior)
    //   tienda web              -> pedido_<slug>_web
    //   carta QR de solo lectura-> ninguna, ahi no se toman pedidos
    const LLAVE_PEDIDO_LEGADO = `pedido_${slug}`;
    const llavePedido = esModoMesa
        ? `pedido_${slug}_mesa_${mesaId}`
        : (esModoTiendaWeb ? `pedido_${slug}_web` : null);

    const [esSoloLectura, setEsSoloLectura] = useState(!esModoMesa && !esModoTiendaWeb);
    const [enviandoMesa, setEnviandoMesa] = useState(false);
    const [mensajeExitoMesa, setMensajeExitoMesa] = useState(null);

    const [metodosPagoServidor, setMetodosPagoServidor] = useState(null);
    const [comprobanteFile, setComprobanteFile] = useState(null);
    const [comprobantePreview, setComprobantePreview] = useState(null);
    const [urlComprobante, setUrlComprobante] = useState('');
    const [subiendoComprobante, setSubiendoComprobante] = useState(false);

    // 🚩 Cuando se detecta usa_menu_qr desde la BD, activar modo solo lectura
    // — salvo en /slug/web, que es justamente la excepción pensada para
    // permitir pedidos aunque el negocio tenga el catálogo QR activo.
    useEffect(() => {
        if (usaMenuQr && !esModoTiendaWeb) {
            setEsSoloLectura(true);
        }
    }, [usaMenuQr, esModoTiendaWeb]);

    // 🚩 BLOQUEO DE SEGURIDAD (Esto es vital para no dejar residuos en el estado)
    useEffect(() => {
        if (esSoloLectura) {
            setCarro([]);
            setIsCarritoVisible(false);
            setIsFormVisible(false);
        }
    }, [esSoloLectura]);

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: config_.google_api,
        libraries: libraries
    });

    const esModoMenu = queryParams.get('modo') === 'menu';
    const esModoCatalogo = queryParams.get('modo') === 'catalogo';


    const mapaEstados = { 1: 0, 2: 1, 3: 2, 4: 2, 5: 3 };

    // 🚩 El ultimo estado se llama distinto segun el modo: en delivery/retiro el
    // pedido se ENTREGA, pero en una mesa el cliente ya tiene la comida al
    // frente desde hace rato -- lo que termina ahi es la cuenta.
    const estadosConfig = esModoMesa
        ? [
            { texto: "Recibimos tu pedido", icono: "📝", anim: "pulse" },
            { texto: "Preparando tu pedido...", icono: "👨‍🍳", anim: "spin" },
            { texto: "Pedido en camino / Listo", icono: "🛵", anim: "bounce" },
            { texto: "¡Finalizado!", icono: "✅", anim: "none" }
        ]
        : [
            { texto: "Recibimos tu pedido", icono: "📝", anim: "pulse" },
            { texto: "Preparando tu pedido...", icono: "👨‍🍳", anim: "spin" },
            { texto: "Pedido en camino / Listo", icono: "🛵", anim: "bounce" },
            { texto: "¡Entregado!", icono: "✅", anim: "none" }
        ];

    const [configLocal, setConfigLocal] = useState({ nombre: "Cargando...", colorPrimario: "#666", telefono: "" });
    const [estilosQr, setEstilosQr] = useState({});
    // 'grilla' (por defecto) o 'categorias'. Se lee del bloque de estilos que
    // corresponde a la pantalla: carta_qr para el menu QR, pedidos_web para la
    // tienda — asi un mismo local puede tener una vista en cada una.
    const [vistaCatalogo, setVistaCatalogo] = useState('grilla');
    const [usaMenuQr, setUsaMenuQr] = useState(false);
    // 🚩 Add-on Pedidos QR: habilita el "pedir la cuenta" desde la carta. NO
    // condiciona el envio de pedidos de mesa, que funciona con el add-on apagado.
    const [usaPedidosQr, setUsaPedidosQr] = useState(false);
    const [pidiendoCuenta, setPidiendoCuenta] = useState(false);
    const [cuentaSolicitada, setCuentaSolicitada] = useState(null);
    // Se queda en true despues de cerrar el detalle, para que el cliente vea
    // que ya aviso y no quede pinchando sin saber si llego.
    const [cuentaYaPedida, setCuentaYaPedida] = useState(false);
    // Si la mesa tiene algo que cobrar. Sin esto el boton salia siempre, y en
    // una mesa sin cuenta abierta el cliente lo tocaba y recibia un error.
    const [cuentaAbierta, setCuentaAbierta] = useState(false);
    // Precuenta ya emitida: el QR no acepta mas productos. Se sabe antes de que
    // el cliente arme el carrito, para decirselo en vez de rebotarlo al enviar.
    const [cuentaCerrandose, setCuentaCerrandose] = useState(false);
    const [productos, setProductos] = useState([]);
    const [categoriasFull, setCategoriasFull] = useState([]);
    const [categoriasNombres, setCategoriasNombres] = useState(['__todos__']);
    const [categoriaActiva, setCategoriaActiva] = useState('__todos__');
    const [carro, setCarro] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isCarritoVisible, setIsCarritoVisible] = useState(false);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [datosCliente, setDatosCliente] = useState({ nombre: '', telefono: '', direccion: '', observacion: '', verDetalle: false });
    // 🚩 Honeypot anti-bot: campo invisible para humanos. Si un bot lo llena,
    // el backend rechaza el pedido en silencio. Cero fricción para clientes reales.
    // Los datos del cliente se recuerdan en el navegador: un cliente que vuelve
    // no tiene que reescribir nombre, telefono y direccion cada vez. Solo local,
    // no viaja a ningun lado hasta que el mismo confirma el pedido.
    useEffect(() => {
        try {
            const guardado = localStorage.getItem(`cliente_${slug}`);
            if (guardado) {
                const d = JSON.parse(guardado);
                setDatosCliente(prev => ({
                    ...prev,
                    nombre: d.nombre || '',
                    telefono: d.telefono || '',
                    direccion: d.direccion || ''
                }));
            }
        } catch (e) { /* dato corrupto: se ignora y se pide de nuevo */ }
    }, [slug]);

    const [hpWeb, setHpWeb] = useState('');
    // El formulario va en 2 pasos: 1) entrega y datos  2) pago.
    // Antes era un solo modal con todo (entrega, datos, mapa, nota, pago,
    // transferencia, comprobante, captcha y boton) = scroll largo en celular.
    const [pasoForm, setPasoForm] = useState(1);
    const [errores, setErrores] = useState({});

    // Se saco el captcha de emojis: era la ultima friccion justo antes de pagar
    // y no aportaba seguridad real — al bot lo frenan el honeypot (hpWeb) y el
    // rate limit del servidor, que siguen intactos.

    const limpiarError = (campo) => setErrores(prev => {
        if (!prev[campo]) return prev;
        const copia = { ...prev };
        delete copia[campo];
        return copia;
    });

    const validarPaso1 = () => {
        const e = {};
        if (!(datosCliente.nombre || '').trim()) e.nombre = 'Escribe tu nombre';
        const telLimpio = (datosCliente.telefono || '').replace(/[^\d]/g, '');
        if (!telLimpio) e.telefono = 'Escribe tu teléfono';
        else if (telLimpio.length < 8) e.telefono = 'El teléfono parece incompleto';
        if (tipoEntrega === 'delivery') {
            if (!datosCliente.direccion) e.direccion = 'Ingresa tu dirección de entrega';
            else if (modoDespacho === 'zonas') {
                if (fueraDeRango) e.direccion = 'Esa dirección está fuera de la zona de reparto';
                else if (!sectorElegido) e.direccion = 'Falta elegir tu zona de despacho';
            }
        }
        setErrores(e);
        return Object.keys(e).length === 0;
    };

    const validarPaso2 = () => {
        const e = {};
        if (!metodoPago) e.metodoPago = 'Elige cómo vas a pagar';
        if (tipoEntrega === 'delivery' && sectorElegido && subtotal < Number(sectorElegido.monto_minimo_pedido || 0)) {
            e.minimo = `El pedido mínimo para ${sectorElegido.nombre_sector} es $${Number(sectorElegido.monto_minimo_pedido).toLocaleString('es-CL')}`;
        }
        setErrores(e);
        return Object.keys(e).length === 0;
    };

    // Al abrir el formulario siempre se parte del paso 1 y sin errores viejos.
    useEffect(() => {
        if (isFormVisible) { setPasoForm(1); setErrores({}); }
    }, [isFormVisible]);

    const [pedidoActivo, setPedidoActivo] = useState(null);
    const [estadoActual, setEstadoActual] = useState(0);

    const [esperandoValidacion, setEsperandoValidacion] = useState(false);
    const [codigoValidacion, setCodigoValidacion] = useState("");
    const [codigoEnviado, setCodigoEnviado] = useState(false);
    const [enviandoCodigo, setEnviandoCodigo] = useState(false);
    const [mensajeValidacion, setMensajeValidacion] = useState(null);
    const [mensajeRechazo, setMensajeRechazo] = useState(null);
    const [productoParaVariantes, setProductoParaVariantes] = useState(null);
    const [tipoEntrega, setTipoEntrega] = useState('delivery');
    const [metodoPago, setMetodoPago] = useState(''); // '' = sin seleccionar

    // 🚩 Métodos de pago disponibles según tipo de entrega — vienen de la
    // configuración de Tienda (configLocal.metodos_pago); si el negocio nunca
    // los configuró, se usa el mismo default histórico como respaldo.
    const METODOS_PAGO_META = {
        efectivo: { label: '💵 Efectivo', desc: { delivery: 'Paga al repartidor', retiro: 'Paga cuando retires' } },
        transferencia: { label: '🏦 Transferencia', desc: { delivery: 'Datos de la cuenta al confirmar', retiro: 'Datos de la cuenta al confirmar' } },
        tarjeta: { label: '💳 Tarjeta', desc: { delivery: 'Débito o crédito al recibir', retiro: 'Débito o crédito en el local' } },
    };
    const METODOS_PAGO_DEFAULT = {
        delivery: ['efectivo', 'transferencia'],
        retiro: ['efectivo', 'transferencia', 'tarjeta'],
    };
    const metodosPagoConfig = (configLocal.metodos_pago && Object.keys(configLocal.metodos_pago).length > 0)
        ? configLocal.metodos_pago
        : METODOS_PAGO_DEFAULT;
    const METODOS_PAGO = {
        delivery: (metodosPagoConfig.delivery || []).filter(id => METODOS_PAGO_META[id]).map(id => ({ id, label: METODOS_PAGO_META[id].label, desc: METODOS_PAGO_META[id].desc.delivery })),
        retiro: (metodosPagoConfig.retiro || []).filter(id => METODOS_PAGO_META[id]).map(id => ({ id, label: METODOS_PAGO_META[id].label, desc: METODOS_PAGO_META[id].desc.retiro })),
    };

    const [sectores, setSectores] = useState([]);
    const [sectorElegido, setSectorElegido] = useState(null);
    const [mapCenter, setMapCenter] = useState({ lat: -33.4489, lng: -70.6693 });
    const [marcador, setMarcador] = useState(null);
    const [fueraDeRango, setFueraDeRango] = useState(false);
    const [autocompleteInstance, setAutocompleteInstance] = useState(null);

    useEffect(function () {
        let intervalo;
        if (pedidoActivo && pedidoActivo.id && estadoActual < 3 && estadoActual !== -1) {
            intervalo = setInterval(async function () {
                try {
                    const data = await consultarEstadoPedido(pedidoActivo.id);
                    if (data && data.status === 'success' && data.estado_id) {
                        const serverEstadoId = parseInt(data.estado_id);
                        if (serverEstadoId === 6) {
                            setEstadoActual(-1);
                            clearInterval(intervalo);
                            return;
                        }
                        const nuevoIndiceUI = mapaEstados[serverEstadoId];
                        if (nuevoIndiceUI !== undefined && nuevoIndiceUI !== estadoActual) {
                            setEstadoActual(nuevoIndiceUI);
                        }
                        // Actualizar items y total desde el backend para el detalle
                        if (data.items) {
                            setPedidoActivo(prev => ({
                                ...prev,
                                items: data.items,
                                total: data.total,
                                tipo_entrega_id: data.tipo_entrega_id,
                                direccion: data.direccion,
                                costo_envio: data.costo_envio
                            }));
                        }
                    }
                } catch (e) { console.error("Error polling:", e); }
            }, 8000);
        }
        return () => { if (intervalo) clearInterval(intervalo); };
    }, [pedidoActivo, estadoActual]);

    // CARGA INICIAL Y LIMPIEZA ABSOLUTA DE POLÍGONOS
    useEffect(() => {
        console.log("ingrez")
        const fetchDatosDB = async () => {
            setLoading(true);
            try {
                // =========================================================
                // 🚩 1. BLOQUEO ESTRICTO DE PEDIDOS WEB (USA_WEB)
                // =========================================================
                // 🚩 1. OBTENER CONFIGURACIÓN PÚBLICA
                const resConfig = await fetch(`${config.api_url}/api/configuracion/valores-publicos/${slug}`);
                const dataConfig = await resConfig.json();
                const ajustes = dataConfig.ajustes ? dataConfig.ajustes : {};

                // 🚩 Detectar flag usa_menu_qr desde la BD
                const tieneMenuQr = ajustes.usa_menu_qr == 1 || ajustes.usa_menu_qr === "1" || ajustes.usa_menu_qr === true;
                setUsaMenuQr(tieneMenuQr);

                // 🚩 Add-on Pedidos QR
                setUsaPedidosQr(ajustes.usa_pedidos_qr == 1 || ajustes.usa_pedidos_qr === "1" || ajustes.usa_pedidos_qr === true);

                // 🚩 BLOQUEO: Si es modo QR y no tiene flag activo, rechazar
                if (esModoQR && !tieneMenuQr) {
                    setMensajeRechazo("qr_no_habilitado");
                    setLoading(false);
                    return;
                }

                // 🚩 BLOQUEO DE PEDIDOS WEB (USA_WEB) - solo si NO es modo QR
                if (!esModoQR) {
                    const usaWeb = ajustes.usa_web;
                    if (usaWeb === 0 || usaWeb === "0" || usaWeb === false) {
                        setMensajeRechazo("no_disponible");
                        setLoading(false);
                        return;
                    }
                }

                // =========================================================
                // 🚩 2. CARGA DE ESTILOS PERSONALIZADOS
                // =========================================================
                const estilosTienda = await obtenerEstilosTienda(slug);
                aplicarEstilos(estilosTienda, 'pedidos_web');
                setEstilosQr(estilosTienda.carta_qr || {});
                const bloqueVista = esModoQR
                    ? (estilosTienda.carta_qr || {})
                    : (estilosTienda.pedidos_web || {});
                setVistaCatalogo(bloqueVista.vista_catalogo === 'categorias' ? 'categorias' : 'grilla');

                // =========================================================
                // 🚩 3. CARGA DE DATOS DE TIENDA Y ESTADO
                // =========================================================
                const respConfig = await obtenerConfiguracionTienda(slug);
                if (respConfig) {
                    setConfigLocal(respConfig);
                    // 🏦 Cargar datos de transferencia si existen
                    if (respConfig.datos_transferencia) {
                        setMetodosPagoServidor(respConfig.datos_transferencia);
                    }
                }

                // 🚩 Pedido activo: solo en los modos que toman pedidos y bajo la
                // llave de ese modo. En la carta QR de solo lectura no se levanta
                // nada, porque ahi el cliente no tiene un pedido propio que seguir.
                if (llavePedido) {
                    let guardado = localStorage.getItem(llavePedido);

                    // Migracion de la llave vieja compartida. La toma solo la
                    // tienda web, que es donde se generaba: si la agarrara la
                    // mesa, un delivery viejo del cliente reaparecería como si
                    // fuera lo que esta consumiendo sentado en el local.
                    if (!guardado && esModoTiendaWeb) {
                        const legado = localStorage.getItem(LLAVE_PEDIDO_LEGADO);
                        if (legado) {
                            localStorage.setItem(llavePedido, legado);
                            localStorage.removeItem(LLAVE_PEDIDO_LEGADO);
                            guardado = legado;
                        }
                    }

                    let pedidoObj = null;
                    try {
                        pedidoObj = guardado ? JSON.parse(guardado) : null;
                    } catch (e) {
                        // Dato corrupto: se descarta en vez de reventar la carga
                        // entera del catalogo.
                        localStorage.removeItem(llavePedido);
                    }

                    if (pedidoObj) {
                        const dataReal = await consultarEstadoPedido(pedidoObj.id).catch(() => null);
                        const estadoId = dataReal && dataReal.estado_id ? parseInt(dataReal.estado_id) : null;

                        // El pedido ya no existe, o la cuenta ya se pago: se
                        // suelta la llave en vez de dejar el seguimiento pegado
                        // para siempre. Un error de red NO entra aca
                        // (consultarEstadoPedido devuelve null), asi que un
                        // corte de señal no le borra nada al cliente.
                        //
                        // Se mira `pagado` y no solo el estado porque hay dos
                        // caminos de cobro (desde la mesa y desde el TPV) y
                        // conviene no depender de por cual paso el cajero.
                        const noExiste = dataReal && dataReal.status === 'not_found';
                        const yaPagado = esModoMesa && (Number(dataReal && dataReal.pagado) === 1 || estadoId === 5);

                        if (noExiste || yaPagado) {
                            localStorage.removeItem(llavePedido);
                            // Mesa nueva, cuenta nueva: si no, los que se
                            // sientan despues ven el boton en gris diciendo que
                            // ya pidieron la cuenta.
                            setCuentaYaPedida(false);
                        } else {
                            setPedidoActivo(pedidoObj);
                            if (estadoId !== null) {
                                if (estadoId === 6) setEstadoActual(-1);
                                else setEstadoActual(mapaEstados[estadoId] || 0);
                                // 🚩 Sincronizar items desde el backend al recargar
                                if (dataReal.items) {
                                    setPedidoActivo(prev => ({
                                        ...prev,
                                        items: dataReal.items,
                                        total: dataReal.total,
                                        tipo_entrega_id: dataReal.tipo_entrega_id,
                                        direccion: dataReal.direccion,
                                        costo_envio: dataReal.costo_envio
                                    }));
                                }
                            }
                        }
                    }
                }

                // =========================================================
                // 🚩 3. OBTENCIÓN DE PRODUCTOS Y CATEGORÍAS
                // =========================================================

                const urlProductos = esModoQR
                    ? `${config.api_url}/api/productos/catalogo/publico/${slug}?modo=qr`
                    : `${config.api_url}/api/productos/catalogo/publico/${slug}`;

                const pCategorias = obtenerCategoriasTienda(slug).catch(() => []);
                const pProductos = fetch(urlProductos).then(r => r.json()).catch(() => [])
                //const pProductos = getProductosCatalogo();
                const urlSectores = `${config.api_url ? config.api_url.replace(/\/+$/, '') : ""}/api/sectores-despacho-publico/${slug}`;
                const pSectores = fetch(urlSectores).then(res => res.ok ? res.json() : []).catch(() => []);

                const [respCat, respProd, respSectores] = await Promise.all([pCategorias, pProductos, pSectores]);
                console.log("DEBUG 1: Respuesta cruda de Productos:", respProd);
                // =========================================================
                // 🚩 4. NORMALIZACIÓN (SIN OPTIONAL CHAINING PARA EVITAR ERRORES)
                // =========================================================

                // --- Categorías ---
                const arrayCategorias = Array.isArray(respCat) ? respCat : (respCat && respCat.data ? respCat.data : []);
                setCategoriasFull(arrayCategorias);
                const nombresCat = arrayCategorias.map(c => c.nombre).filter(Boolean);
                setCategoriasNombres(['__todos__', ...new Set(nombresCat)]);

                // --- Productos ---
                let arrayProductos = [];
                if (Array.isArray(respProd)) {
                    arrayProductos = respProd;
                } else if (respProd) {
                    arrayProductos = respProd.data || respProd.productos || [];
                }
                setProductos(arrayProductos);

                // --- Sectores ---
                let dataSectores = [];
                if (Array.isArray(respSectores)) {
                    dataSectores = respSectores;
                } else if (respSectores) {
                    dataSectores = respSectores.data || respSectores.sectores || [];
                }

                // 🚩 Ya NO se descartan los sectores sin polígono (zonas fijas):
                // esos no se detectan solos en el mapa, pero igual deben quedar
                // disponibles para que el cliente los elija manualmente de la lista.
                const sectoresParseados = dataSectores.map(s => {
                    try {
                        let coords = typeof s.poligono === 'string' ? JSON.parse(s.poligono) : s.poligono;
                        if (Array.isArray(coords) && coords.length > 0 && Array.isArray(coords[0])) coords = coords[0];
                        return { ...s, poligono: (coords || []).map(c => ({ lat: parseFloat(c.lat), lng: parseFloat(c.lng) })) };
                    } catch (e) { return { ...s, poligono: [] }; }
                });

                setSectores(sectoresParseados);
                if (sectoresParseados.length > 0 && sectoresParseados[0].poligono.length > 0) setMapCenter(sectoresParseados[0].poligono[0]);

            } catch (error) {
                console.error("Error fatal de carga:", error);
                setMensajeRechazo("Error al cargar el comercio.");
            } finally {
                setLoading(false);
            }
        };

        if (slug) fetchDatosDB();
    }, [slug, esModoQR]);

    // Traduce nombres y descripciones cuando cambia idioma o se cargan productos
    useEffect(() => {
        if (!productos.length) { setProductosTraducidos([]); setTraduccionCategorias({}); return; }
        if (idioma === 'es') { setProductosTraducidos(productos); setTraduccionCategorias({}); return; }
        let cancelado = false;
        const traducir = async () => {
            setTraduciendo(true);
            const nombres = productos.map(p => p.nombre || '');
            const descs = productos.map(p => p.descripcion || '');
            // Las categorias tambien se traducen: antes quedaban en espanol
            // sobre una carta que ya estaba en otro idioma.
            const cats = categoriasNombres.filter(n => n !== '__todos__');
            try {
                const [nombresT, descsT, catsT] = await Promise.all([
                    traducirTextos(nombres, idioma),
                    traducirTextos(descs, idioma),
                    traducirTextos(cats, idioma),
                ]);
                if (!cancelado) {
                    setProductosTraducidos(productos.map((p, i) => ({
                        ...p,
                        nombre: nombresT[i] || p.nombre,
                        descripcion: descsT[i] || p.descripcion,
                    })));
                    const mapa = {};
                    cats.forEach((original, i) => { mapa[original] = catsT[i] || original; });
                    setTraduccionCategorias(mapa);
                    setTraduciendo(false);
                }
            } catch (err) {
                if (!cancelado) setTraduciendo(false);
            }
        };
        traducir();
        return () => { cancelado = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productos, idioma, categoriasNombres]);

    // 🚩 VALIDACIÓN IMPECABLE DEL POLÍGONO
    const verificarCobertura = (ubicacion) => {
        if (!window.google || !window.google.maps.geometry) return;

        const lat = parseFloat(ubicacion.lat);
        const lng = parseFloat(ubicacion.lng);
        const punto = new window.google.maps.LatLng(lat, lng);

        setMarcador({ lat, lng });
        setMapCenter({ lat, lng });

        let sectorEncontrado = null;

        for (const s of sectores) {
            try {
                // Instanciar LatLng strictly de Google
                const googlePaths = s.poligono.map(p => new window.google.maps.LatLng(p.lat, p.lng));
                const polygonGoogle = new window.google.maps.Polygon({ paths: googlePaths });

                if (window.google.maps.geometry.poly.containsLocation(punto, polygonGoogle)) {
                    sectorEncontrado = s;
                    break;
                }
            } catch (err) {
                console.error("Error al validar el polígono:", err);
            }
        }

        if (sectorEncontrado) {
            setSectorElegido(sectorEncontrado);
            setFueraDeRango(false);
        } else {
            setSectorElegido(null);
            setFueraDeRango(true);
        }
    };


    const onPlaceChanged = () => {
        if (autocompleteInstance !== null) {
            const place = autocompleteInstance.getPlace();
            if (place.geometry && place.geometry.location) {
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                const address = place.formatted_address;
                setDatosCliente(prev => ({ ...prev, direccion: address }));
                verificarCobertura({ lat, lng });
            }
        }
    };

    const onMapClick = (e) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === 'OK' && results[0]) {
                setDatosCliente(prev => ({ ...prev, direccion: results[0].formatted_address }));
            } else {
                setDatosCliente(prev => ({ ...prev, direccion: "Ubicación seleccionada en el mapa" }));
            }
        });
        verificarCobertura({ lat, lng });
    };

    // 🚩 Zonas fijas (sin geocerca) no se detectan solas con el mapa/dirección
    // — el cliente las elige manualmente de la lista.
    const seleccionarZonaManual = (idSector) => {
        if (!idSector) {
            setSectorElegido(null);
            setFueraDeRango(false);
            return;
        }
        const s = sectores.find(sec => String(sec.id) === String(idSector));
        if (!s) return;
        setSectorElegido(s);
        setFueraDeRango(false);
    };

    // 🚩 Disponibilidad: el botón "Cerrada" del admin manda por sobre todo
    // (emergencia). Si no, se respeta el horario configurado; sin horario
    // configurado para ningún día, se acepta pedidos siempre.
    const DIAS_JS = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const estaAbierta = useMemo(() => {
        if (configLocal.abierto === false) return false;
        const horario = configLocal.horarioPedidos;
        if (!horario || Object.keys(horario).length === 0) return true;

        const ahora = new Date();
        const diaHoy = DIAS_JS[ahora.getDay()];
        const cfgHoy = horario[diaHoy];
        if (!cfgHoy || !cfgHoy.activo) return false;

        const [hDesde, mDesde] = (cfgHoy.desde || '00:00').split(':').map(Number);
        const [hHasta, mHasta] = (cfgHoy.hasta || '23:59').split(':').map(Number);
        const minutosAhora = ahora.getHours() * 60 + ahora.getMinutes();
        const minutosDesde = hDesde * 60 + mDesde;
        const minutosHasta = hHasta * 60 + mHasta;
        return minutosAhora >= minutosDesde && minutosAhora <= minutosHasta;
    }, [configLocal.abierto, configLocal.horarioPedidos]);

    const subtotal = useMemo(() => carro.reduce((acc, item) => acc + (Number(item.precio) * item.cantidad), 0), [carro]);

    // 🚩 Modo de cobro de despacho configurado en Tienda: gratis / monto fijo
    // (sin zonas, sin mapa) / por sectores (comportamiento original).
    const modoDespacho = configLocal.modoDespacho || 'zonas';
    // 🚩 Enfoque único para todas las zonas del negocio: geocerca (mapa) o
    // nombre (lista). Nunca se mezclan — el checkout muestra uno u otro.
    const tipoZonas = configLocal.tipoZonas || 'geocerca';
    const costoEnvioActual = useMemo(() => {
        if (tipoEntrega === 'retiro') return 0;
        if (modoDespacho === 'gratis') return 0;
        if (modoDespacho === 'fijo') return Number(configLocal.costoDespachoFijo || 0);
        return sectorElegido ? Number(sectorElegido.valor_entrega) : 0;
    }, [tipoEntrega, modoDespacho, configLocal.costoDespachoFijo, sectorElegido]);

    const totalFinal = useMemo(() => {
        if (tipoEntrega === 'retiro') return subtotal;
        return subtotal + costoEnvioActual;
    }, [subtotal, costoEnvioActual, tipoEntrega]);

    // Si el boton final va a quedar bloqueado, el cliente tiene que saber por que.
    // Antes simplemente no respondia y no habia forma de adivinar el motivo.
    const motivoBloqueo = (() => {
        if (tipoEntrega !== 'delivery' || modoDespacho !== 'zonas') return null;
        if (fueraDeRango) return 'Tu dirección está fuera de la zona de reparto';
        if (!sectorElegido) return 'Falta elegir tu zona de despacho';
        const minimo = Number(sectorElegido.monto_minimo_pedido || 0);
        if (subtotal < minimo) return `Te faltan $${(minimo - subtotal).toLocaleString('es-CL')} para llegar al mínimo de ${sectorElegido.nombre_sector}`;
        return null;
    })();

    // Dentro de Pedidos.js (Web)
    const handleAdd = (p) => {
        if (esSoloLectura) return;

        // 🚩 VALIDACIÓN REAL: ¿Tiene grupos con opciones?
        const tieneVariantes = p.grupos && p.grupos.length > 0;
        const yaPersonalizado = p.opciones_escogidas || (p.id && String(p.id).includes('_'));

        if (tieneVariantes && !yaPersonalizado) {
            setProductoParaVariantes(p); // Abre el modal
            return;
        }

        // Si no tiene variantes o ya pasó por el modal, agrega al carro
        const precioItem = Number(p.precio || p.valor || 0); // 🚩 Usa ambas llaves por seguridad

        const textoVariantesP = p.variantes_detalles || p.descripcionVariantes || "";
        setCarro(prev => {
            const ex = prev.find(i => {
                const textoVariantesI = i.variantes_detalles || i.descripcionVariantes || "";
                return i.id === p.id && textoVariantesI === textoVariantesP;
            });
            if (ex) {
                return prev.map(i => (i.id === p.id && (i.variantes_detalles || i.descripcionVariantes || "") === textoVariantesP)
                    ? { ...i, cantidad: i.cantidad + 1 } : i);
            }
            return [...prev, { ...p, precio: precioItem, cantidad: 1 }];
        });
    };

    const handleRemove = (id) => setCarro(prev => {
        const ex = prev.find(i => i.id === id);
        if (!ex) return prev;
        return ex.cantidad === 1 ? prev.filter(i => i.id !== id) : prev.map(i => i.id === id ? { ...i, cantidad: i.cantidad - 1 } : i);
    });

    // 🚩 ENVIAR PEDIDO DE MESA A COCINA (Público, sin token)
    const enviarPedidoMesa = async () => {
        if (!slug || !mesaId || carro.length === 0) return;
        setEnviandoMesa(true);
        try {
            const payload = {
                slug,
                mesa_id: mesaId,
                items: carro,
                comensales: 1
            };
            const res = await registrarPedidoMesaPublico(payload);
            if (res.status === 'success') {
                setIsCarritoVisible(false);
                const nuevoPedido = {
                    id: res.id,
                    display_id: res.display_id,
                    items: carro,
                    total: subtotal,
                    tipo_entrega_id: 1
                };
                setPedidoActivo(nuevoPedido);
                setEstadoActual(0);
                setMensajeExitoMesa(res.message || '¡Pedido enviado a cocina!');
                if (llavePedido) localStorage.setItem(llavePedido, JSON.stringify(nuevoPedido));
                setCarro([]);
                // Recien ahora la mesa tiene algo que cobrar: aparece el boton
                // de pedir la cuenta.
                refrescarCuentaMesa();
            } else {
                alert(res.message || 'Error al enviar el pedido.');
            }
        } catch (e) {
            alert('Error inesperado al conectar con el servidor.');
        } finally {
            setEnviandoMesa(false);
        }
    };

    // 🚩 Estado de la cuenta de la mesa: decide si mostrar "Pedir la cuenta".
    const refrescarCuentaMesa = React.useCallback(async () => {
        if (!esModoMesa || !usaPedidosQr || !slug || !mesaId) return;
        const res = await consultarCuentaMesa(mesaId, slug);
        setCuentaAbierta(Boolean(res && res.tiene_cuenta_abierta));
        setCuentaCerrandose(Boolean(res && res.cuenta_cerrandose));
        // Viene del servidor, asi que sobrevive a que el cliente recargue.
        if (res && res.cuenta_ya_pedida) setCuentaYaPedida(true);
    }, [esModoMesa, usaPedidosQr, slug, mesaId]);

    useEffect(() => { refrescarCuentaMesa(); }, [refrescarCuentaMesa]);

    // Con la precuenta emitida el QR ya no acepta productos: se deja la carta en
    // solo lectura para que el cliente ni siquiera pueda armar un carrito que
    // despues le van a rebotar.
    useEffect(() => {
        if (esModoMesa && cuentaCerrandose) setEsSoloLectura(true);
    }, [esModoMesa, cuentaCerrandose]);

    // 🚩 PEDIR LA CUENTA DESDE LA MESA (Público, sin token)
    // El cobro sigue siendo presencial: esto solo le avisa al local y le muestra
    // al cliente el detalle, el total y la propina sugerida.
    const pedirLaCuenta = async () => {
        if (!slug || !mesaId || pidiendoCuenta) return;
        setPidiendoCuenta(true);
        try {
            const res = await solicitarCuentaMesa(mesaId, slug);
            if (res.status === 'success') {
                setIsCarritoVisible(false);
                setCuentaSolicitada(res);
                setCuentaYaPedida(true);
            } else {
                alert(res.message || 'No se pudo pedir la cuenta.');
            }
        } catch (e) {
            alert('Error inesperado al conectar con el servidor.');
        } finally {
            setPidiendoCuenta(false);
        }
    };

    // 🚩 VERIFICAR CÓDIGO SMS ANTES DE ENVIAR EL PEDIDO
    const verificarCodigoSms = async () => {
        const telVia = prepararTelefonoChile(datosCliente.telefono);
        if (!codigoValidacion || codigoValidacion.length < 6) {
            setMensajeValidacion({ tipo: 'danger', texto: 'Ingresa el código de 6 dígitos.' });
            return false;
        }
        setLoading(true);
        try {
            const res = await verificarCodigoValidacion(telVia, codigoValidacion);
            if (res.status === 'verified') {
                setMensajeValidacion({ tipo: 'success', texto: '✅ Teléfono validado correctamente.' });
                setEsperandoValidacion(false);
                setCodigoEnviado(false);
                setCodigoValidacion("");
                return true;
            } else {
                setMensajeValidacion({ tipo: 'danger', texto: res.message || 'Código incorrecto.' });
                return false;
            }
        } catch (e) {
            setMensajeValidacion({ tipo: 'danger', texto: 'Error al verificar código.' });
            return false;
        } finally {
            setLoading(false);
        }
    };

    const finalizarPedido = async () => {
        const telVia = prepararTelefonoChile(datosCliente.telefono);

        // 🚩 Si está esperando validación, primero verificar el código
        if (esperandoValidacion) {
            const verificacionOk = await verificarCodigoSms();
            if (!verificacionOk) return;
            // Si se verificó, continuar con el envío del pedido
        }

        // Validacion inline: los errores se muestran al lado del campo que
        // corresponde, no en un alert() que tapa la pantalla sin decir cual es.
        if (!validarPaso1()) { setPasoForm(1); return; }
        if (!validarPaso2()) { setPasoForm(2); return; }

        setLoading(true);
        try {
            const payload = {
                slug,
                nombre: datosCliente.nombre,
                telefono: telVia,
                direccion: tipoEntrega === 'retiro' ? 'Retiro en Local' : datosCliente.direccion,
                observacion: datosCliente.observacion,
                items: carro,
                tipo_entrega: tipoEntrega,
                sector_id: (tipoEntrega === 'retiro' || modoDespacho !== 'zonas') ? null : (sectorElegido ? sectorElegido.id : null),
                costo_envio: costoEnvioActual,
                total: subtotal,
                total_pagado: totalFinal,
                valor_pedido: subtotal,
                metodo_pago: metodoPago,
                lat: marcador ? marcador.lat : null,
                lng: marcador ? marcador.lng : null,
                web_hp: hpWeb
            };

            const res = await registrarPedidoWeb(payload, comprobanteFile);
            if (res.status === "blocked") { setMensajeRechazo(res.message); setIsFormVisible(false); return; }
            if (res.status === "require_validation") { setEsperandoValidacion(true); return; }
            if (res.status === "success") {
                setIsCarritoVisible(false); setIsFormVisible(false);
                const nuevoPedido = { id: res.id, display_id: res.display_id, cliente: { nombre: datosCliente.nombre }, items: carro, total: subtotal, tipo_entrega_id: tipoEntrega === 'delivery' ? 2 : 3, direccion: datosCliente.direccion, costo_envio: tipoEntrega === 'delivery' ? (sectorElegido ? Number(sectorElegido.valor_entrega) : 0) : 0 };
                setPedidoActivo(nuevoPedido); setEstadoActual(0);
                setDatosCliente(prev => ({ ...prev, verSeguimiento: true }));
                if (llavePedido) localStorage.setItem(llavePedido, JSON.stringify(nuevoPedido));
                try {
                    localStorage.setItem(`cliente_${slug}`, JSON.stringify({
                        nombre: datosCliente.nombre,
                        telefono: datosCliente.telefono,
                        direccion: tipoEntrega === 'retiro' ? '' : datosCliente.direccion
                    }));
                } catch (e) { /* sin espacio en localStorage: no es critico */ }
                setCarro([]); return;
            }
            alert(res.message || "Error al procesar el pedido.");
        } catch (e) { alert("Error inesperado."); } finally { setLoading(false); }
    };

    const resetearParaNuevoPedido = () => {
        if (llavePedido) localStorage.removeItem(llavePedido);
        setPedidoActivo(null); setEstadoActual(0); setCarro([]); setSectorElegido(null); setMarcador(null); setFueraDeRango(false); setPasoForm(1); setErrores({});
        window.scrollTo(0, 0);
    };

    const productosFiltrados = useMemo(() => {
        const base = productosTraducidos.length ? productosTraducidos : productos;
        if (!base || base.length === 0) return [];
        if (categoriaActiva === '__todos__') return base;
        return base.filter(p => {
            const catProdNombre = (p.categoria_nombre || p.categoria || "").toString().toLowerCase().trim();
            const catRel = categoriasFull.find(c => c.nombre === categoriaActiva);

            // 1. Filtro por nombre exacto
            if (catProdNombre === categoriaActiva.toLowerCase().trim()) return true;

            // 2. Filtro por ID (Forzando a String para que no falle)
            if (catRel) {
                if (String(p.categoria_id) === String(catRel.id)) return true;
                if (String(p.id_categoria) === String(catRel.id)) return true;
            }

            return false;
        });
    }, [productos, productosTraducidos, categoriaActiva, categoriasFull]);

    const obtenerUrlImagen = (producto) => {
        const imgDefault = "https://via.placeholder.com/300?text=Sin+Imagen";
        const path = producto.url_imagen || producto.img || producto.imagen;
        if (!path || path === "null" || path === "" || path === undefined) return imgDefault;
        return resolveImagenUrl(path);
    };

    // Mismo criterio de match que productosFiltrados, extraido aparte para poder
    // contar los productos de cada categoria en la portada sin duplicar reglas.
    const perteneceACategoria = (p, nombreCat) => {
        const catProdNombre = (p.categoria_nombre || p.categoria || "").toString().toLowerCase().trim();
        if (catProdNombre === nombreCat.toLowerCase().trim()) return true;
        const catRel = categoriasFull.find(c => c.nombre === nombreCat);
        if (catRel) {
            if (String(p.categoria_id) === String(catRel.id)) return true;
            if (String(p.id_categoria) === String(catRel.id)) return true;
        }
        return false;
    };

    // Las categorias no tienen imagen propia: se usa la del primer producto
    // de la categoria que tenga foto. Las vacias no se muestran.
    const categoriasResumen = useMemo(() => {
        const base = productosTraducidos.length ? productosTraducidos : productos;
        return categoriasNombres
            .filter(nombre => nombre !== '__todos__')
            .map(nombre => {
                const suyos = base.filter(p => perteneceACategoria(p, nombre));
                const conFoto = suyos.find(p => {
                    const path = p.url_imagen || p.img || p.imagen;
                    return path && path !== 'null' && path !== '';
                });
                return {
                    nombre,
                    nombreMostrar: traduccionCategorias[nombre] || nombre,
                    cantidad: suyos.length,
                    imagen: conFoto ? obtenerUrlImagen(conFoto) : null
                };
            })
            .filter(cat => cat.cantidad > 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productos, productosTraducidos, categoriasNombres, categoriasFull, traduccionCategorias]);

    // En la portada (sin categoria elegida) se muestra la lista; al entrar a una
    // categoria se vuelve a la grilla de productos de siempre.
    // Nombre de categoria tal como se muestra: traducido si corresponde,
    // original si el idioma es espanol o si la traduccion fallo.
    const nombreCategoria = (n) => traduccionCategorias[n] || n;

    const enPortadaCategorias = vistaCatalogo === 'categorias' && categoriaActiva === '__todos__';

    // Formateador específico para el Logo y Banner usando R2
    const obtenerUrlTiendaR2 = (path) => {
        if (!path || path === "null" || path === "" || path === undefined) return null;
        return resolveImagenUrl(path);
    };



    // Variables finales listas para usar en el HTML
    const logoFinal = obtenerUrlTiendaR2(configLocal.url_logo || configLocal.urlLogo || configLocal.logo_url);
    const bannerFinal = obtenerUrlTiendaR2(configLocal.url_cabecera || configLocal.urlCabecera);

    // Estilos carta QR
    const headerBg = estilosQr.header_bg || estilosQr.color_primario || configLocal.colorPrimario || '#F26B21';
    const headerText = estilosQr.header_text_color || '#FFFFFF';
    const footerBg = estilosQr.footer_bg || '#1a1c1d';
    const footerText = estilosQr.footer_text_color || '#FFFFFF';
    const logoSizes = { pequeño: 60, mediano: 80, grande: 100 };
    const logoSize = logoSizes[estilosQr.logo_tamano] || 80;

    // 🕵️‍♂️ === RASTREADOR DE DEBUG (MÍRALO EN LA CONSOLA F12) ===
    useEffect(() => {
        if (configLocal && configLocal.nombre !== "Cargando...") {
            console.log("🟦 === DEBUG CABECERA Y LOGO ===");
            console.log("1. Todo el objeto configLocal:", configLocal);
            console.log("--- LOGO ---");
            console.log("2. url_logo:", configLocal.url_logo, " | RESULTADO:", logoFinal);
            console.log("--- CABECERA ---");
            console.log("3. url_cabecera:", configLocal.url_cabecera);
            console.log("4. urlCabecera:", configLocal.urlCabecera);
            console.log("5. RESULTADO bannerFinal:", bannerFinal);
            console.log("🟦 ==============================");
        }
    }, [configLocal, logoFinal, bannerFinal]);
    // 🚩 Si hay mensaje de rechazo, NO renderizar el layout de la tienda (solo el modal)
    if (mensajeRechazo) {
        return (
            <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f8fafc' }}>
                <style>{`
                    .modal-custom { 
                        position: fixed; 
                        top: 0; left: 0; 
                        width: 100%; height: 100%; background-color: rgba(0,0,0,0.85); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px; overflow-y: auto; }
                `}</style>

                {mensajeRechazo === "qr_no_habilitado" && (
                    <div className="modal-custom">
                        <div className="bg-white p-5 rounded-4 text-center shadow-2xl" style={{ maxWidth: '380px', borderRadius: '24px' }}>
                            <div className="mb-4" style={{ fontSize: '4rem' }}>🔒</div>
                            <h2 className="fw-bold mb-3" style={{ color: '#1a1c1d', fontSize: '1.5rem' }}>Modo QR no disponible</h2>
                            <p className="text-muted mb-4" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                El comercio no tiene habilitado el modo QR.<br />
                                <span style={{ fontSize: '0.8rem' }}>Contacta al comercio para más información.</span>
                            </p>
                            <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-sm" onClick={() => setMensajeRechazo(null)}>
                                ENTENDIDO
                            </button>
                        </div>
                    </div>
                )}

                {mensajeRechazo === "no_disponible" && (
                    <div className="modal-custom">
                        <div className="bg-white p-5 rounded-4 text-center shadow-2xl" style={{ maxWidth: '400px', borderRadius: '24px' }}>
                            <div className="mb-3" style={{ fontSize: '4rem', lineHeight: 1 }}>🛒</div>
                            <div style={{
                                width: '70px', height: '70px', borderRadius: '50%', margin: '0 auto 16px',
                                backgroundColor: '#f0fdf4', display: 'flex', alignItems: 'center',
                                justifyContent: 'center', fontSize: '2rem'
                            }}>
                                🚧
                            </div>
                            <h2 className="fw-bold mb-2" style={{ color: '#1a1c1d', fontSize: '1.4rem' }}>
                                {configLocal.nombre !== "Cargando..." ? configLocal.nombre : 'Esta tienda'}
                            </h2>
                            <p className="text-muted mb-3" style={{ fontSize: '0.85rem', lineHeight: '1.5' }}>
                                Estamos preparando nuestra tienda online 🚀
                            </p>
                            <div style={{
                                backgroundColor: '#f8fafc', borderRadius: '12px', padding: '14px',
                                marginBottom: '20px', border: '1px solid #e2e8f0'
                            }}>
                                <div style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '4px' }}>
                                    ⏳ Pronto podrás pedir desde aquí
                                </div>
                                <div style={{ fontSize: '0.75rem', color: '#94a3b8' }}>
                                    Mientras tanto, puedes visitarnos directamente en nuestro local
                                </div>
                            </div>
                            <div className="d-flex flex-column gap-2">
                                <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-sm" onClick={() => setMensajeRechazo(null)}>
                                    ENTENDIDO, VOLVER
                                </button>
                                {configLocal.direccion && (
                                    <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.75rem' }}>
                                        📍 {configLocal.direccion}
                                    </p>
                                )}
                                <p className="text-muted mt-2 mb-0" style={{ fontSize: '0.7rem' }}>
                                    ¿Eres el dueño? <a href="/adminlogin" style={{ color: '#008060', fontWeight: 600, textDecoration: 'underline' }}>Activa tu tienda online</a>
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {mensajeRechazo && mensajeRechazo !== "no_disponible" && mensajeRechazo !== "qr_no_habilitado" && (
                    <div className="modal-custom">
                        <div className="bg-white p-5 rounded-4 text-center shadow-2xl" style={{ maxWidth: '380px', borderRadius: '24px' }}>
                            <div className="mb-3" style={{ fontSize: '3rem', lineHeight: 1 }}>😅</div>
                            <h3 className="fw-bold mb-3" style={{ color: '#1a1c1d', fontSize: '1.2rem' }}>
                                Algo salió mal
                            </h3>
                            <p className="text-muted mb-4" style={{ fontSize: '0.9rem', lineHeight: '1.5' }}>
                                {mensajeRechazo || 'No pudimos cargar la información del comercio.'}
                            </p>
                            <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow-sm" onClick={() => setMensajeRechazo(null)}>
                                ENTENDIDO
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="min-vh-100" style={{ backgroundColor: 'var(--pw-color-fondo, #f4f7f6)' }}>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&display=swap');
                .bg-light {
                    background-color: var(--pw-color-fondo, #f4f7f6) !important;
                }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                .anim-spin { animation: spin 2s infinite linear; }
                @keyframes pulse { 0% { transform: scale(1); } 50% { transform: scale(1.05); } 100% { transform: scale(1); } }
                .anim-pulse { animation: pulse 1.5s infinite; }
                
                /* ESTILOS PREMIUM - HEADER COMPACTO ESTILO GOMENU */
                .store-banner { height: var(--pw-banner-altura, 80px); background-size: cover; background-position: center; position: relative; }
                .logo-container { width: 70px; height: 70px; background: white; border-radius: var(--pw-border-radius-card, 16px); padding: 3px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); margin: -35px auto 0 auto; position: relative; z-index: 10; display: flex; align-items: center; justify-content: center; overflow: hidden; }
                .logo-img { width: 100%; height: 100%; object-fit: contain; border-radius: 16px; }
              /* 1. El contenedor: Dale un fondo sutil y aire */
                /* EL CONTENEDOR: Ahora es un "vidrio" que flota */
.category-bar {
    background: rgba(255, 255, 255, 0.9) !important;
    backdrop-filter: blur(15px) !important; /* Efecto iPhone */
    border-bottom: 1px solid rgba(0,0,0,0.05) !important;
    padding: 12px 0 !important;
    display: flex !important;
    overflow-x: auto !important;
    white-space: nowrap !important;
    scrollbar-width: none !important; /* Esconde scroll en Firefox */
    scroll-behavior: smooth !important;
    -webkit-overflow-scrolling: touch !important;
}

.category-bar::-webkit-scrollbar { 
    display: none !important; /* Esconde scroll en Chrome/Safari */
}

/* LOS BOTONES (PILLS): Estilo Shopify/Uber */
.btn-category {
    background-color: var(--pw-categoria-inactiva-bg, #f1f3f5) !important;
    color: var(--pw-categoria-inactiva-texto, #495057) !important;
    border: 1px solid transparent !important;
    border-radius: var(--pw-border-radius-pill, 50px) !important;
    padding: 8px 20px !important;
    margin: 0 6px !important;
    font-size: 0.85rem !important;
    font-weight: 700 !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    display: inline-block !important;
    box-shadow: var(--pw-sombra-card, 0 2px 4px rgba(0,0,0,0.02)) !important;
}

/* EL BOTÓN ACTIVO: El que manda */
.btn-category.active {
    background-color: var(--pw-categoria-activa-bg, ${headerBg}) !important;
    color: var(--pw-categoria-activa-texto, ${headerText}) !important;
    transform: scale(1.05) !important;
    box-shadow: 0 8px 15px rgba(0,0,0,0.15) !important;
    border-color: var(--pw-categoria-activa-bg, ${headerBg}) !important;
}

/* Efecto de presión al tocar */
.btn-category:active {
    transform: scale(0.95) !important;
}
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

                /* MODALES Y ELEMENTOS ORIGINALES */
                .modal-custom { 
                    position: fixed; 
                    top: 0; left: 0; 
                    width: 100%; height: 100%; background-color: rgba(0,0,0,0.85); z-index: 99999; display: flex; align-items: center; justify-content: center; padding: 20px; overflow-y: auto; }
                .modal-content-card { 
                    background: white; 
                    width: 100%; 
                    max-width: 500px; 
                    border-radius: var(--pw-border-radius-modal, 30px);
                    padding: 30px; 
                    box-shadow: 0 20px 40px rgba(0,0,0,0.4); 
                    max-height: 90vh; 
                    overflow-y: auto; 
                }
                    
                .qty-pill { display: flex; align-items: center; background: #f8f9fa; border-radius: var(--pw-border-radius-pill, 50px); padding: 2px 8px; border: 1px solid #dee2e6; }
                .qty-pill button { background: none; border: none; font-weight: bold; width: 28px; height: 28px; display: flex; align-items: center; justify-content: center; color: #333; }
                .qty-pill span { min-width: 25px; text-align: center; font-weight: 800; font-size: 14px; }
                .modo-lectura button, .modo-lectura .btn { display: none !important; }
                /* Excepcion: los items de la portada de categorias son <button> y esa
                   regla se los llevaba puestos, dejando la carta QR en blanco cuando
                   el negocio elige la vista de lista. Navegar entre categorias no es
                   'comprar', asi que en modo lectura tiene que seguir funcionando. */
                .modo-lectura .lc-item { display: flex !important; }
                .modo-lectura .card, .modo-lectura .producto-item { cursor: default !important; pointer-events: none !important; }
                .pac-container { z-index: 100000 !important; border-radius: var(--pw-border-radius, 10px); border: none; box-shadow: 0 4px 12px rgba(0,0,0,0.2); margin-top: 5px; }

                            
                @media (min-width: 992px) {
                    .store-banner { height: 200px; }
                }
            `}</style>

            <div className="bg-white shadow-sm overflow-hidden" style={{ fontFamily: 'var(--pw-font-family, "Inter", sans-serif)' }}>
                {/* Banner de fondo */}
                <div className="store-banner" style={{ backgroundColor: headerBg, backgroundImage: bannerFinal ? `url(${bannerFinal})` : 'none' }}>
                    {bannerFinal && <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(0,0,0,0.3)' }}></div>}
                </div>

                {/* Logo Flotante */}
                <div className="logo-container" style={{ width: `${logoSize}px`, height: `${logoSize}px`, marginTop: `-${logoSize / 2}px` }}>
                    {logoFinal ? (
                        <img src={logoFinal} alt="Logo" className="logo-img" />
                    ) : (
                        <div className="fw-bold text-muted" style={{ fontSize: '24px' }}>{configLocal.nombre.charAt(0)}</div>
                    )}
                </div>
                {/* Selector de idioma -- solo en modo menú de solo lectura (QR sin
                    pedido en mesa ni tienda online). En pedidos online reales
                    se oculta para no interferir con el flujo de compra. */}
                {esSoloLectura && (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '8px 16px 0' }}>
                        {['es', 'en', 'pt'].map(lng => (
                            <button
                                key={lng}
                                onClick={() => cambiarIdioma(lng)}
                                style={{
                                    background: idioma === lng ? headerBg : 'transparent',
                                    color: idioma === lng ? headerText : '#64748b',
                                    border: '1px solid ' + (idioma === lng ? headerBg : '#e2e8f0'),
                                    borderRadius: '6px',
                                    padding: '3px 8px',
                                    fontSize: '11px',
                                    fontWeight: 700,
                                    marginLeft: '4px',
                                    cursor: 'pointer',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                {lng.toUpperCase()}
                            </button>
                        ))}
                    </div>
                )}

                {/* Info de tienda */}
                <div className="text-center pt-3 pb-3 px-3">
                    <h1 className="fw-800 mb-1" style={{ fontSize: '1.6rem', color: '#1a1c1d', fontWeight: 800 }}>{configLocal.nombre}</h1>
                    <div className="d-flex justify-content-center gap-3 mt-2 text-muted small fw-600">
                        <span>{estaAbierta ? '🟢' : '🔴'} {estaAbierta ? (configLocal.horario || 'Abierto') : 'Cerrado'}</span>
                        <span>📍 {configLocal.direccion || 'Local'}</span>
                    </div>
                    {configLocal.descripcion && <p className="text-muted mt-2 mb-0 small px-4">{configLocal.descripcion}</p>}
                </div>

                {/* Etiquetas MODO */}
                {queryParams.get('modo') === 'menu' && <div className="bg-warning text-dark text-center py-1 fw-bold border-bottom small">📖 MODO MENÚ DIGITAL</div>}
                {queryParams.get('modo') === 'catalogo' && <div className="bg-info text-white text-center py-1 fw-bold border-bottom small">👀 MODO CARTA</div>}
                {esModoMesa && !cuentaCerrandose && <div className="bg-success text-white text-center py-1 fw-bold border-bottom small">🍽️ PEDIDO EN MESA</div>}
                {/* 🚩 Precuenta emitida: se avisa arriba en vez de dejar que arme
                    el carrito y recien rebotarlo al tocar "enviar a cocina". */}
                {esModoMesa && cuentaCerrandose && (
                    <div className="bg-warning text-dark text-center py-2 fw-bold border-bottom small">
                        🧾 Tu cuenta ya se está cerrando — para pedir algo más, avísale al garzón
                    </div>
                )}
                {!estaAbierta && (
                    <div className="bg-danger text-white text-center py-2 fw-bold border-bottom small">
                        🔴 Cerrado por ahora — no se están recibiendo pedidos
                    </div>
                )}

                {/* Botones de Categoría (Sticky rediseñado) */}
                {/* Botones de Categoría (Sticky rediseñado) */}
                {vistaCatalogo === 'categorias' ? (
                    // En la portada no va barra (las categorias YA son la pantalla);
                    // dentro de una categoria se cambia por una barra de volver.
                    !enPortadaCategorias && (
                        <div className="sticky-top category-bar shadow-sm">
                            {/* La barra ENTERA vuelve atras. Antes el area tocable era solo
                                el caracter '<': 7x22 pixeles, imposible de achuntarle con el
                                dedo. Ahora ocupa el ancho completo y 48px de alto, que es el
                                minimo razonable para tocar en un celular. */}
                            <button
                                onClick={() => setCategoriaActiva('__todos__')}
                                className="btn border-0 bg-transparent d-flex align-items-center w-100 text-start"
                                style={{ gap: '10px', padding: '10px 16px', minHeight: '48px' }}
                                aria-label="Volver a las categorías"
                            >
                                <span style={{ fontSize: '24px', lineHeight: 1, flex: 'none' }}>&#8249;</span>
                                <span className="fw-bold text-truncate">{nombreCategoria(categoriaActiva)}</span>
                            </button>
                        </div>
                    )
                ) : (
                    <div className="sticky-top category-bar shadow-sm">
                        <div className="d-flex px-3"> {/* Eliminamos clases de container que limitan el ancho */}
                            {categoriasNombres.map(cat => (
                                <button
                                    key={cat}
                                    onClick={() => setCategoriaActiva(cat)}
                                    className={`btn-category ${categoriaActiva === cat ? 'active' : ''}`}
                                >
                                    {cat === '__todos__' ? t('carta', 'todos') : nombreCategoria(cat)}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
            <div className={`container pt-3 ${esSoloLectura ? 'modo-lectura' : ''}`}>
                {loading ? (
                    <div className="text-center py-5 text-muted">{t('carta', 'cargando')}</div>
                ) : traduciendo ? (
                    <div className="text-center py-5">
                        <div className="spinner-border mb-3" role="status" style={{ color: headerBg, width: '2.5rem', height: '2.5rem' }}>
                            <span className="visually-hidden">...</span>
                        </div>
                        <div className="fw-bold" style={{ color: '#495057' }}>
                            {idioma === 'en' ? 'Translating menu...' : 'Traduzindo o cardapio...'}
                        </div>
                        <div className="text-muted small mt-1">
                            {idioma === 'en' ? 'This only takes a moment' : 'Leva so um instante'}
                        </div>
                    </div>
                ) : enPortadaCategorias ? (
                    <CatalogoCategorias
                        categorias={categoriasResumen}
                        onSelect={setCategoriaActiva}
                        colorPrimario={headerBg}
                        tarjetaRadio={estilosQr.tarjeta_radio}
                    />
                ) : (
                    <CatalogoLista
                        productos={productosFiltrados}
                        carro={carro}
                        onAddItem={handleAdd}
                        onRemoveItem={handleRemove}
                        obtenerUrlImagen={obtenerUrlImagen}
                        esSoloLectura={esSoloLectura}
                        tarjetaRadio={estilosQr.tarjeta_radio}
                        tarjetaSombra={estilosQr.tarjeta_sombra}
                        colorPrimario={headerBg}
                        mostrarPrecios={estilosQr.mostrar_precios !== false}
                    />
                )}
            </div>

            {/* Footer */}
            <footer style={{ backgroundColor: footerBg, color: footerText, padding: '28px 20px 20px', textAlign: 'center' }}>
                {logoFinal && (
                    <img src={logoFinal} alt={configLocal.nombre}
                        style={{ width: '52px', height: '52px', borderRadius: '50%', objectFit: 'cover', marginBottom: '10px', border: `2px solid rgba(255,255,255,0.2)` }} />
                )}
                <div style={{ fontWeight: 700, fontSize: '15px', marginBottom: '4px' }}>{configLocal.nombre}</div>
                {configLocal.direccion && (
                    <div style={{ fontSize: '13px', opacity: 0.7, marginBottom: '4px' }}>📍 {configLocal.direccion}</div>
                )}
                {configLocal.horario && (
                    <div style={{ fontSize: '12px', opacity: 0.6, marginBottom: '14px' }}>🕒 {configLocal.horario}</div>
                )}
                <div style={{ fontSize: '11px', opacity: 0.35 }}>Powered by Komity</div>
            </footer>

            {/* Local cerrado: antes el boton flotante simplemente no se renderizaba y
                el cliente quedaba en un callejon sin salida — podia seguir agregando
                productos sin que nada le dijera que no iba a poder pedir. */}
            {carro.length > 0 && !pedidoActivo && !esSoloLectura && !estaAbierta && (
                <div className="fixed-bottom p-3 d-flex justify-content-center" style={{ zIndex: 5000 }}>
                    <div className="shadow-lg fw-bold d-flex flex-column justify-content-center align-items-center text-center"
                        style={{
                            backgroundColor: '#5f6368', color: '#fff', width: '100%', maxWidth: '450px',
                            minHeight: '60px', borderRadius: '18px', padding: '10px 20px',
                            boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
                        }}>
                        <div style={{ fontSize: '0.95rem' }}>
                            🔴 {esModoMesa ? 'La cocina está cerrada' : 'El local está cerrado'}
                        </div>
                        <div style={{ fontSize: '0.78rem', fontWeight: 400, opacity: 0.85 }}>
                            Guardamos tu selección ({carro.reduce((acc, item) => acc + item.cantidad, 0)} · ${subtotal.toLocaleString('es-CL')})
                            {configLocal.horario ? ` · Atendemos ${configLocal.horario}` : ''}
                        </div>
                    </div>
                </div>
            )}

            {/* BOTÓN FLOTANTE CARRITO / ENVIAR A COCINA */}
            {carro.length > 0 && !pedidoActivo && !esSoloLectura && !esModoMesa && estaAbierta && (
                <div className="fixed-bottom p-3 d-flex justify-content-center" style={{ zIndex: 5000 }}>
                    <button
                        className="btn shadow-lg fw-bold border-0 d-flex justify-content-between align-items-center"
                        style={{
                            backgroundColor: 'var(--pw-btn-primario-bg, #000)',
                            color: 'var(--pw-btn-primario-texto, #fff)',
                            width: '100%',
                            maxWidth: '450px',
                            height: '60px',
                            borderRadius: '18px',
                            padding: '0 20px',
                            boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
                        }}
                        onClick={() => setIsCarritoVisible(true)}>

                        <div className="d-flex align-items-center">
                            <span style={{
                                background: 'rgba(255,255,255,0.2)',
                                padding: '4px 12px',
                                borderRadius: '10px',
                                fontSize: '14px',
                                marginRight: '12px',
                                display: 'inline-block'
                            }}>
                                {carro.reduce((acc, item) => acc + item.cantidad, 0)}
                            </span>
                            <span style={{ letterSpacing: '0.5px', fontSize: '0.95rem' }}>{t('carta', 'verCarrito')}</span>
                        </div>

                        <span style={{ fontSize: '1.1rem' }}>${subtotal.toLocaleString('es-CL')}</span>
                    </button>
                </div>
            )}

            {/* 🍽️ BOTÓN FLOTANTE ENVIAR A COCINA (MODO MESA) */}
            {/* 🚩 En mesa NO se exige !pedidoActivo. La cuenta de una mesa se va
                sumando: el cliente pide, come, y despues pide un trago mas. Con
                ese guard el segundo pedido se podia armar en el carro pero no
                habia con que enviarlo, asi que los productos quedaban ahi sin
                que pasara nada. En la tienda web el guard si corresponde: ahi
                es un pedido a la vez. */}
            {carro.length > 0 && !esSoloLectura && esModoMesa && estaAbierta && (
                <div className="fixed-bottom p-3 d-flex justify-content-center" style={{ zIndex: 5000 }}>
                    <button
                        className="btn shadow-lg fw-bold border-0 d-flex justify-content-between align-items-center"
                        style={{
                            backgroundColor: '#28a745',
                            color: '#fff',
                            width: '100%',
                            maxWidth: '450px',
                            height: '60px',
                            borderRadius: '18px',
                            padding: '0 20px',
                            boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
                        }}
                        onClick={() => setIsCarritoVisible(true)}>

                        <div className="d-flex align-items-center">
                            <span style={{
                                background: 'rgba(255,255,255,0.2)',
                                padding: '4px 12px',
                                borderRadius: '10px',
                                fontSize: '14px',
                                marginRight: '12px',
                                display: 'inline-block'
                            }}>
                                {carro.reduce((acc, item) => acc + item.cantidad, 0)}
                            </span>
                            <span style={{ letterSpacing: '0.5px', fontSize: '0.95rem' }}>🍳 {t('carta', 'enviarCocina')}</span>
                        </div>

                        <span style={{ fontSize: '1.1rem' }}>${subtotal.toLocaleString('es-CL')}</span>
                    </button>
                </div>
            )}

            {isCarritoVisible && !esModoMesa && (
                <div className="modal-custom">
                    <div className="modal-content-card text-dark shadow-lg">
                        <h5 className="fw-bold mb-4 text-center">{t('carta', 'tuSeleccion')}</h5>
                        <div className="overflow-auto mb-3 px-1" style={{ maxHeight: '420px' }}>
                            {carro.map((item, index) => (
                                <div key={item.id + "-" + index} className="p-3 mb-3" style={{ border: '1.5px solid #ececec', borderRadius: '16px', backgroundColor: '#ffffff' }}>
                                    <div className="d-flex justify-content-between align-items-start mb-1">
                                        <div className="fw-bold lh-sm text-dark" style={{ fontSize: '1rem', flex: 1 }}>{item.nombre}</div>
                                        <div className="fw-bold text-success ms-2" style={{ fontSize: '1rem' }}>${(Number(item.precio) * item.cantidad).toLocaleString('es-CL')}</div>
                                    </div>
                                    {(item.variantes_detalles || item.descripcionVariantes) && (
                                        <div className="p-2 mb-2" style={{ backgroundColor: '#f9f9f9', borderRadius: '10px', fontSize: '0.75rem', borderLeft: '4px solid #333' }}>
                                            <div className="text-dark fw-bold mb-1">{t('carta', 'personalizacion')}:</div>
                                            <div className="text-muted fst-italic">{item.variantes_detalles || item.descripcionVariantes}</div>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                                        <span className="text-muted small">{t('carta', 'cantidad')}:</span>
                                        <div className="qty-pill">
                                            <button onClick={() => handleRemove(item.id)} className="text-danger">－</button>
                                            <span>{item.cantidad}</span>
                                            <button onClick={() => {
                                                if (item.grupos && item.grupos.length > 0) { setIsCarritoVisible(false); setProductoParaVariantes(item); }
                                                else { handleAdd(item); }
                                            }} className="text-success">＋</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="p-3 bg-dark text-white rounded-4 mb-3 d-flex justify-content-between align-items-center">
                            <span className="fw-bold">{t('carta', 'valorProductos')}</span>
                            <span className="h4 mb-0 fw-bold">${subtotal.toLocaleString('es-CL')}</span>
                        </div>
                        <button
                            className="btn btn-lg w-100 rounded-pill py-3 fw-bold mb-2 shadow"
                            style={{ backgroundColor: 'var(--pw-btn-continuar-bg, #198754)', color: 'var(--pw-btn-continuar-texto, #fff)', border: 'none' }}
                            onClick={() => { setIsCarritoVisible(false); setIsFormVisible(true); }}>
                            🚀 {t('carta', 'continuarPago')}
                        </button>
                        <button className="btn btn-link w-100 text-muted text-decoration-none" onClick={() => setIsCarritoVisible(false)}>
                            <small>{t('carta', 'agregarMas')}</small>
                        </button>
                    </div>
                </div>
            )}

            {/* 🍽️ MODAL CARRITO MESA - ENVIAR A COCINA */}
            {/* 💵 PEDIR LA CUENTA (MODO MESA + add-on Pedidos QR) */}
            {esModoMesa && usaPedidosQr && cuentaAbierta && !cuentaSolicitada && !isCarritoVisible && !datosCliente.verSeguimiento && carro.length === 0 && (
                // 🚩 Pastilla chica abajo a la IZQUIERDA. Antes era una barra
                // ancha centrada y con un pedido activo se paraba a media
                // pantalla tapando los productos, justo cuando el cliente
                // quiere seguir pidiendo. La burbuja de seguimiento vive abajo
                // a la derecha, asi que no se pisan.
                // Con algo en el carro no se muestra: ahi lo que importa es
                // mandar el pedido, no pedir la cuenta.
                <div
                    className="position-fixed"
                    style={{ bottom: '20px', left: '16px', zIndex: 4900 }}
                >
                    <button
                        className="btn shadow fw-bold border-0 d-flex align-items-center"
                        style={{
                            // En gris una vez pedida: el cliente necesita ver que
                            // el aviso llego, no que el boton desaparezca.
                            backgroundColor: cuentaYaPedida ? '#6c757d' : '#fd7e14',
                            color: '#fff',
                            height: '44px',
                            borderRadius: '22px',
                            padding: '0 18px',
                            fontSize: '0.85rem',
                            gap: '6px',
                            whiteSpace: 'nowrap'
                        }}
                        onClick={pedirLaCuenta}
                        disabled={pidiendoCuenta || cuentaYaPedida}
                    >
                        {cuentaYaPedida
                            ? '✓ Garzón avisado'
                            : (pidiendoCuenta ? 'Avisando...' : '💵 La cuenta')}
                    </button>
                </div>
            )}

            {/* 💵 DETALLE DE LA CUENTA (tras pedirla) */}
            {cuentaSolicitada && (
                // 🚩 z-index propio: .modal-custom trae 99999, igual que el
                // overlay de seguimiento, y con empate gana el que va despues en
                // el DOM (el seguimiento). El modal de cancelado ya usa 100000,
                // asi que este va arriba de los dos.
                <div className="modal-custom" style={{ zIndex: 100001 }}>
                    <div className="modal-content-card text-dark shadow-lg">
                        <h5 className="fw-bold mb-1 text-center">💵 Tu cuenta</h5>
                        <p className="text-center text-muted small mb-4">{cuentaSolicitada.message}</p>

                        <div className="overflow-auto mb-3 px-1" style={{ maxHeight: '340px' }}>
                            {(cuentaSolicitada.items || []).map((item, index) => (
                                <div key={(item.id || 'i') + '-' + index} className="d-flex justify-content-between align-items-start py-2 border-bottom">
                                    <div className="pe-2">
                                        <div className="fw-bold lh-sm" style={{ fontSize: '0.95rem' }}>
                                            {item.cantidad} × {item.nombre}
                                        </div>
                                        {(item.variantes_detalles || item.descripcionVariantes) && (
                                            <div className="text-muted fst-italic" style={{ fontSize: '0.75rem' }}>
                                                {item.variantes_detalles || item.descripcionVariantes}
                                            </div>
                                        )}
                                    </div>
                                    <div className="fw-bold text-nowrap" style={{ fontSize: '0.95rem' }}>
                                        ${(Number(item.precio || item.valor || 0) * Number(item.cantidad || 1)).toLocaleString('es-CL')}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="p-3 rounded-4 mb-3" style={{ backgroundColor: '#f7f7f7' }}>
                            <div className="d-flex justify-content-between mb-1">
                                <span className="text-muted">Total consumo</span>
                                <span className="fw-bold">${Number(cuentaSolicitada.total || 0).toLocaleString('es-CL')}</span>
                            </div>
                            {cuentaSolicitada.usa_propina_sugerida && Number(cuentaSolicitada.propina_sugerida) > 0 && (
                                <>
                                    <div className="d-flex justify-content-between mb-1">
                                        <span className="text-muted">
                                            Propina sugerida ({cuentaSolicitada.porcentaje_propina}%)
                                        </span>
                                        <span className="fw-bold">${Number(cuentaSolicitada.propina_sugerida).toLocaleString('es-CL')}</span>
                                    </div>
                                    <div className="d-flex justify-content-between pt-2 border-top">
                                        <span className="fw-bold">Total con propina</span>
                                        <span className="h5 mb-0 fw-bold">${Number(cuentaSolicitada.total_con_propina || 0).toLocaleString('es-CL')}</span>
                                    </div>
                                </>
                            )}
                        </div>

                        <p className="text-center text-muted small mb-3">
                            La propina es voluntaria. El pago se hace en el local con el garzón.
                        </p>

                        <button
                            className="btn btn-lg w-100 rounded-pill py-3 fw-bold border-0"
                            style={{ backgroundColor: '#212529', color: '#fff' }}
                            onClick={() => setCuentaSolicitada(null)}
                        >
                            Entendido
                        </button>
                    </div>
                </div>
            )}

            {isCarritoVisible && esModoMesa && (
                <div className="modal-custom">
                    <div className="modal-content-card text-dark shadow-lg">
                        <h5 className="fw-bold mb-4 text-center">🍽️ {t('carta', 'tuPedidoMesa')}</h5>
                        <div className="overflow-auto mb-3 px-1" style={{ maxHeight: '420px' }}>
                            {carro.map((item, index) => (
                                <div key={item.id + "-" + index} className="p-3 mb-3" style={{ border: '1.5px solid #ececec', borderRadius: '16px', backgroundColor: '#ffffff' }}>
                                    <div className="d-flex justify-content-between align-items-start mb-1">
                                        <div className="fw-bold lh-sm text-dark" style={{ fontSize: '1rem', flex: 1 }}>{item.nombre}</div>
                                        <div className="fw-bold text-success ms-2" style={{ fontSize: '1rem' }}>${(Number(item.precio) * item.cantidad).toLocaleString('es-CL')}</div>
                                    </div>
                                    {(item.variantes_detalles || item.descripcionVariantes) && (
                                        <div className="p-2 mb-2" style={{ backgroundColor: '#f9f9f9', borderRadius: '10px', fontSize: '0.75rem', borderLeft: '4px solid #333' }}>
                                            <div className="text-dark fw-bold mb-1">{t('carta', 'personalizacion')}:</div>
                                            <div className="text-muted fst-italic">{item.variantes_detalles || item.descripcionVariantes}</div>
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-between align-items-center mt-2 pt-2 border-top">
                                        <span className="text-muted small">{t('carta', 'cantidad')}:</span>
                                        <div className="qty-pill">
                                            <button onClick={() => handleRemove(item.id)} className="text-danger">－</button>
                                            <span>{item.cantidad}</span>
                                            <button onClick={() => {
                                                if (item.grupos && item.grupos.length > 0) { setIsCarritoVisible(false); setProductoParaVariantes(item); }
                                                else { handleAdd(item); }
                                            }} className="text-success">＋</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="p-3 bg-dark text-white rounded-4 mb-3 d-flex justify-content-between align-items-center">
                            <span className="fw-bold">{t('carta', 'valor')}</span>
                            <span className="h4 mb-0 fw-bold">${subtotal.toLocaleString('es-CL')}</span>
                        </div>
                        <p className="text-center text-muted small mb-3">
                            {t('carta', 'mensajeCocina')}
                        </p>
                        <button
                            className="btn btn-lg w-100 rounded-pill py-3 fw-bold mb-2 shadow border-0"
                            style={{ backgroundColor: '#28a745', color: '#fff' }}
                            onClick={enviarPedidoMesa}
                            disabled={enviandoMesa}
                        >
                            {enviandoMesa ? t('carta', 'enviandoCocina') : '🍳 ' + t('carta', 'enviarCocina')}
                        </button>
                        <button className="btn btn-link w-100 text-muted text-decoration-none" onClick={() => setIsCarritoVisible(false)}>
                            <small>{t('carta', 'agregarMas')}</small>
                        </button>
                    </div>
                </div>
            )}

            {isFormVisible && !esSoloLectura && (
                <div className="modal-custom">
                    <div className="modal-content-card text-dark">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            {/* Espacio vacío para centrar el título perfectamente */}
                            <div style={{ width: '30px' }}></div>

                            <h5 className="fw-bold m-0 text-center">
                                {esperandoValidacion ? t('carta', 'validarWhatsapp') : t('carta', 'datosPedido')}
                            </h5>

                            <button
                                onClick={() => {
                                    setIsFormVisible(false);
                                    setEsperandoValidacion(false);
                                }}
                                style={{
                                    background: '#eee',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '30px',
                                    height: '30px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: '#333',
                                    fontSize: '1.2rem',
                                    fontWeight: 'bold',
                                    transition: '0.2s'
                                }}
                                onMouseOver={(e) => e.target.style.background = '#ddd'}
                                onMouseOut={(e) => e.target.style.background = '#eee'}
                            >
                                ×
                            </button>
                        </div>
                        {!esperandoValidacion ? (
                            <>
                                {/* PASO 1: entrega y datos */}
                                {pasoForm === 1 && (<>
                                <div className="d-flex mb-4 bg-light rounded-pill p-1 border">
                                    <button type="button" className={`btn w-50 rounded-pill fw-bold ${tipoEntrega === 'delivery' ? 'btn-primary shadow-sm' : 'btn-light text-muted border-0'}`} style={tipoEntrega === 'delivery' ? { backgroundColor: configLocal.colorPrimario, color: '#fff', border: 'none' } : {}} onClick={() => setTipoEntrega('delivery')}>🛵 {t('carta', 'delivery')}</button>
                                    <button type="button" className={`btn w-50 rounded-pill fw-bold ${tipoEntrega === 'retiro' ? 'btn-primary shadow-sm' : 'btn-light text-muted border-0'}`} style={tipoEntrega === 'retiro' ? { backgroundColor: configLocal.colorPrimario, color: '#fff', border: 'none' } : {}} onClick={() => setTipoEntrega('retiro')}>🏪 {t('carta', 'retiroLocal')}</button>
                                </div>
                                {/* 🚩 Honeypot anti-bot: invisible para humanos (fuera de pantalla, sin
                                    tabIndex, autoComplete off para que los navegadores no lo autorellenen) */}
                                <input
                                    type="text"
                                    name="website"
                                    value={hpWeb}
                                    onChange={e => setHpWeb(e.target.value)}
                                    tabIndex={-1}
                                    autoComplete="off"
                                    aria-hidden="true"
                                    style={{ position: 'absolute', left: '-9999px', width: '1px', height: '1px', opacity: 0 }}
                                />
                                <input type="text" className={`form-control p-3 bg-light rounded-3 ${errores.nombre ? 'border border-danger mb-1' : 'border-0 mb-2'}`} placeholder={t('carta', 'nombreCompleto')} value={datosCliente.nombre} onChange={e => { setDatosCliente({ ...datosCliente, nombre: e.target.value }); limpiarError('nombre'); }} />
                                {errores.nombre && <div className="text-danger small mb-2 ps-1">⚠️ {errores.nombre}</div>}
                                <input type="tel" className={`form-control p-3 bg-light rounded-3 ${errores.telefono ? 'border border-danger mb-1' : 'border-0 mb-3'}`} placeholder={t('carta', 'telefono')} value={datosCliente.telefono} onChange={e => { setDatosCliente({ ...datosCliente, telefono: e.target.value }); limpiarError('telefono'); }} />
                                {errores.telefono && <div className="text-danger small mb-3 ps-1">⚠️ {errores.telefono}</div>}

                                {tipoEntrega === 'delivery' && modoDespacho === 'zonas' && tipoZonas === 'geocerca' && (
                                    <div className="mb-3 border p-2 rounded-3 bg-light">
                                        <label className="fw-bold text-muted small d-block mb-2"><i className="fas fa-map-marker-alt text-danger mr-1"></i> Escribe tu dirección y selecciónala:</label>

                                        {isLoaded ? (
                                            <>
                                                <Autocomplete onLoad={setAutocompleteInstance} onPlaceChanged={onPlaceChanged} options={{ componentRestrictions: { country: "cl" } }}>
                                                    <input type="text" className="form-control p-3 border-primary mb-2 shadow-sm" style={{ borderRadius: '10px' }} placeholder="Ej: Avenida Providencia 1234" value={datosCliente.direccion} onChange={e => setDatosCliente({ ...datosCliente, direccion: e.target.value })} />
                                                </Autocomplete>

                                                <MapaErrorBoundary fallback={
                                                    <div className="alert alert-warning small mb-0 text-center" style={{ borderRadius: '10px' }}>
                                                        ⚠️ No se pudo cargar el mapa. Escribe tu dirección arriba y avanza igual — el local la confirma al recibir tu pedido.
                                                    </div>
                                                }>
                                                    <div className="rounded overflow-hidden shadow-sm" style={{ height: '200px', border: '2px solid #ccc' }}>
                                                        <GoogleMap mapContainerStyle={{ width: '100%', height: '100%' }} center={mapCenter} zoom={marcador ? 16 : 13} onClick={onMapClick} options={{ disableDefaultUI: true, zoomControl: true }}>
                                                            {sectores.filter(s => s.poligono && s.poligono.length > 2).map((s, i) => (
                                                                <Polygon key={s.id || i} paths={s.poligono} options={{ fillColor: "#28a745", fillOpacity: 0.3, strokeColor: "#28a745", strokeOpacity: 1, strokeWeight: 2, clickable: false }} />
                                                            ))}
                                                            {marcador && <Marker position={marcador} animation={window.google.maps.Animation.DROP} />}
                                                        </GoogleMap>
                                                    </div>
                                                </MapaErrorBoundary>

                                                {fueraDeRango && (
                                                    <div className="alert alert-danger mt-2 small fw-bold text-center anim-pulse">
                                                        ❌ Lo sentimos, esta ubicación está fuera de nuestra zona de reparto.
                                                    </div>
                                                )}

                                                {!fueraDeRango && sectorElegido && (
                                                    <div className="alert alert-success mt-2 small fw-bold text-center">
                                                        ✅ Estás en: {sectorElegido.nombre_sector} (+${Number(sectorElegido.valor_entrega).toLocaleString('es-CL')})
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div className="text-center p-3">Cargando mapa...</div>
                                        )}
                                    </div>
                                )}

                                {tipoEntrega === 'delivery' && modoDespacho === 'zonas' && tipoZonas === 'nombre' && (
                                    <div className="mb-3 border p-2 rounded-3 bg-light">
                                        <label className="fw-bold text-muted small d-block mb-2"><i className="fas fa-map-marker-alt text-danger mr-1"></i> Dirección de entrega:</label>
                                        <input type="text" className="form-control p-3 border-primary mb-2 shadow-sm" style={{ borderRadius: '10px' }} placeholder="Ej: Avenida Providencia 1234" value={datosCliente.direccion} onChange={e => setDatosCliente({ ...datosCliente, direccion: e.target.value })} />

                                        <label className="fw-bold text-muted small d-block mb-1">Elige tu zona:</label>
                                        <select className="form-control p-2 border-0 shadow-sm" style={{ borderRadius: '10px' }} value={(sectorElegido && sectorElegido.id) || ''} onChange={e => seleccionarZonaManual(e.target.value)}>
                                            <option value="">-- Selecciona una zona --</option>
                                            {sectores.map(s => (
                                                <option key={s.id} value={s.id}>
                                                    {s.nombre_sector} (+${Number(s.valor_entrega).toLocaleString('es-CL')})
                                                </option>
                                            ))}
                                        </select>

                                        {sectorElegido && (
                                            <div className="alert alert-success mt-2 mb-0 small fw-bold text-center">
                                                ✅ {sectorElegido.nombre_sector} (+${Number(sectorElegido.valor_entrega).toLocaleString('es-CL')})
                                            </div>
                                        )}
                                    </div>
                                )}

                                {tipoEntrega === 'delivery' && modoDespacho !== 'zonas' && (
                                    <div className="mb-3 border p-2 rounded-3 bg-light">
                                        <label className="fw-bold text-muted small d-block mb-2"><i className="fas fa-map-marker-alt text-danger mr-1"></i> Dirección de entrega:</label>
                                        <input type="text" className="form-control p-3 border-primary mb-2 shadow-sm" style={{ borderRadius: '10px' }} placeholder="Ej: Avenida Providencia 1234" value={datosCliente.direccion} onChange={e => setDatosCliente({ ...datosCliente, direccion: e.target.value })} />
                                        <div className="alert alert-success mt-1 mb-0 small fw-bold text-center">
                                            {modoDespacho === 'gratis' ? '🎁 Envío gratis' : `🚚 Envío: $${costoEnvioActual.toLocaleString('es-CL')}`}
                                        </div>
                                    </div>
                                )}

                                <textarea className="form-control mb-3 p-3 bg-light border-0 rounded-3" rows="2" placeholder={t('carta', 'nota')} value={datosCliente.observacion} onChange={e => setDatosCliente({ ...datosCliente, observacion: e.target.value })} />

                                {errores.direccion && <div className="text-danger small mb-2 ps-1">⚠️ {errores.direccion}</div>}

                                <button
                                    className="btn w-100 rounded-pill py-3 fw-bold shadow-sm border-0"
                                    style={{ backgroundColor: configLocal.colorPrimario, color: '#fff' }}
                                    onClick={() => { if (validarPaso1()) setPasoForm(2); }}
                                >
                                    Continuar al pago →
                                </button>
                                </>)}

                                {/* PASO 2: pago */}
                                {pasoForm === 2 && (<>
                                <button className="btn btn-link text-muted p-0 mb-3" onClick={() => setPasoForm(1)}>‹ Volver a mis datos</button>

                                {/* 💳 SELECTOR DE MÉTODO DE PAGO */}
                                <div className="mb-3 p-3 bg-white border border-secondary border-opacity-25 rounded-3">
                                    <h6 className="fw-bold mb-2 text-center border-bottom pb-2">💳 {t('carta', 'metodoPago')}</h6>
                                    {/* Uno por fila: con 3 opciones un desplegable serian 3 toques
                                        en vez de 1, y esconderia la descripcion de cada metodo. */}
                                    <div className="d-flex flex-column gap-2">
                                        {(METODOS_PAGO[tipoEntrega] || []).map(mp => (
                                            <button
                                                key={mp.id}
                                                type="button"
                                                onClick={() => { setMetodoPago(mp.id); limpiarError('metodoPago'); }}
                                                className="d-flex align-items-center text-start w-100"
                                                style={{
                                                    gap: '12px',
                                                    padding: '12px 14px',
                                                    borderRadius: '12px',
                                                    border: metodoPago === mp.id ? `2px solid ${configLocal.colorPrimario || '#000'}` : '2px solid #e0e0e0',
                                                    background: metodoPago === mp.id ? '#f0fdf4' : '#fff',
                                                    cursor: 'pointer',
                                                    transition: 'all 0.2s'
                                                }}
                                            >
                                                <span style={{
                                                    width: '20px', height: '20px', borderRadius: '50%', flex: 'none',
                                                    border: `2px solid ${metodoPago === mp.id ? (configLocal.colorPrimario || '#000') : '#c7c7c7'}`,
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                }}>
                                                    {metodoPago === mp.id && <span style={{ width: '10px', height: '10px', borderRadius: '50%', background: configLocal.colorPrimario || '#000' }} />}
                                                </span>
                                                <span style={{ flex: 1, minWidth: 0 }}>
                                                    <span className="d-block" style={{ fontSize: '0.9rem', fontWeight: metodoPago === mp.id ? 700 : 500, color: '#111' }}>{mp.label}</span>
                                                    <span className="d-block" style={{ fontSize: '0.7rem', color: '#777' }}>{mp.desc}</span>
                                                </span>
                                            </button>
                                        ))}
                                    </div>
                                    {errores.metodoPago && <div className="text-danger small mt-2 text-center">⚠️ {errores.metodoPago}</div>}
                                    {!metodoPago && (
                                        <div className="text-center text-muted small mt-2">Selecciona cómo deseas pagar</div>
                                    )}

                                    {/* 🏦 DATOS DE TRANSFERENCIA */}
                                    {metodoPago === 'transferencia' && metodosPagoServidor && (
                                        <div className="mt-3 p-3 rounded-3" style={{ backgroundColor: '#f0fdf4', border: '1px solid #bbf7d0' }}>
                                            <div className="fw-bold text-success small mb-2">🏦 Datos para Transferencia</div>
                                            <div className="small" style={{ lineHeight: '1.8' }}>
                                                {metodosPagoServidor.banco && <div>🏛 <strong>Banco:</strong> {metodosPagoServidor.banco}</div>}
                                                {metodosPagoServidor.tipo_cuenta && <div>📋 <strong>Tipo:</strong> {metodosPagoServidor.tipo_cuenta}</div>}
                                                {metodosPagoServidor.numero_cuenta && <div>🔢 <strong>N° Cuenta:</strong> {metodosPagoServidor.numero_cuenta}</div>}
                                                {metodosPagoServidor.titular && <div>👤 <strong>Titular:</strong> {metodosPagoServidor.titular}</div>}
                                                {metodosPagoServidor.rut && <div>🆔 <strong>RUT:</strong> {metodosPagoServidor.rut}</div>}
                                                {metodosPagoServidor.email && <div>📧 <strong>Email:</strong> {metodosPagoServidor.email}</div>}
                                            </div>
                                            <div className="mt-2 text-muted small" style={{ fontSize: '0.7rem' }}>
                                                ⚠️ Una vez realizada la transferencia, puedes adjuntar el comprobante abajo.
                                            </div>
                                        </div>
                                    )}

                                    {/* 📎 SUBIR COMPROBANTE (solo si eligió transferencia) */}
                                    {metodoPago === 'transferencia' && (
                                        <div className="mt-3 p-3 rounded-3" style={{ backgroundColor: '#f8f9fa', border: '1px dashed #dee2e6' }}>
                                            <div className="fw-bold small mb-2">📎 Comprobante de Pago (opcional)</div>
                                            <input
                                                type="file"
                                                accept="image/*"
                                                style={{ display: 'none' }}
                                                id="comprobanteInput"
                                                onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) {
                                                        setComprobanteFile(file);
                                                        const reader = new FileReader();
                                                        reader.onloadend = () => setComprobantePreview(reader.result);
                                                        reader.readAsDataURL(file);
                                                    }
                                                }}
                                            />
                                            <label htmlFor="comprobanteInput" className="btn btn-outline-secondary btn-sm w-100 fw-bold" style={{ borderRadius: '10px' }}>
                                                {comprobantePreview ? '📷 Cambiar comprobante' : '📷 Subir foto del comprobante'}
                                            </label>
                                            {comprobantePreview && (
                                                <div className="mt-2 text-center">
                                                    <img src={comprobantePreview} alt="Comprobante"
                                                        style={{ maxHeight: '100px', borderRadius: '8px', border: '1px solid #dee2e6' }} />
                                                    <div className="text-success small mt-1">✅ Comprobante seleccionado</div>
                                                </div>
                                            )}
                                            <div className="text-muted mt-1" style={{ fontSize: '0.65rem' }}>
                                                Sube una foto del comprobante para que el local lo tenga como respaldo.
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="mb-3 shadow-sm bg-white border border-secondary border-opacity-25 rounded-3 p-3">
                                    <h6 className="fw-bold mb-3 text-center border-bottom pb-2">{t('carta', 'resumenCuenta')}</h6>
                                    <div className="d-flex justify-content-between mb-2 small"><span className="text-muted">{t('carta', 'valorProductosLabel')}:</span><span className="fw-bold">${subtotal.toLocaleString('es-CL')}</span></div>
                                    <div className="d-flex justify-content-between mb-2 small"><span className="text-muted">{t('carta', 'costoEnvio')}:</span><span className={tipoEntrega === 'retiro' || costoEnvioActual === 0 ? "fw-bold text-success" : "fw-bold text-danger"}>{tipoEntrega === 'retiro' || costoEnvioActual === 0 ? t('carta', 'gratis') : `+$${costoEnvioActual.toLocaleString('es-CL')}`}</span></div>
                                    <div className="d-flex justify-content-between fw-bold text-success border-top pt-2 mt-2 h5 mb-0"><span>{t('carta', 'totalPagar')}:</span><span>${totalFinal.toLocaleString('es-CL')}</span></div>

                                    {tipoEntrega === 'delivery' && sectorElegido && subtotal < Number(sectorElegido.monto_minimo_pedido || 0) && (
                                        <div className="text-danger small mt-3 text-center fw-bold anim-pulse p-2 bg-danger bg-opacity-10 rounded">❌ Mínimo de compra: ${Number(sectorElegido.monto_minimo_pedido || 0).toLocaleString('es-CL')}</div>
                                    )}
                                </div>
                                </>)}
                            </>
                        ) : (
                            <div className="text-center py-2">
                                <p className="small text-muted mb-2">📱 Validación por SMS</p>
                                <p className="text-muted" style={{ fontSize: '0.8rem' }}>Te enviaremos un código de 6 dígitos a tu teléfono <b>{datosCliente.telefono}</b></p>
                                
                                {!codigoEnviado ? (
                                    <button
                                        className="btn btn-primary w-100 rounded-pill py-3 fw-bold mb-3 shadow-sm"
                                        style={{ backgroundColor: configLocal.colorPrimario, border: 'none' }}
                                        onClick={async () => {
                                            setEnviandoCodigo(true);
                                            const tel = prepararTelefonoChile(datosCliente.telefono);
                                            const res = await enviarCodigoValidacion(tel);
                                            setEnviandoCodigo(false);
                                            if (res.status === 'sent') {
                                                setCodigoEnviado(true);
                                                setMensajeValidacion({ tipo: 'success', texto: 'Código enviado. Revisa tu teléfono.' });
                                            } else {
                                                setMensajeValidacion({ tipo: 'danger', texto: res.message || 'Error al enviar código.' });
                                            }
                                        }}
                                        disabled={enviandoCodigo}
                                    >
                                        {enviandoCodigo ? (
                                            <><span className="spinner-border spinner-border-sm me-2" role="status"></span>ENVIANDO...</>
                                        ) : '📨 ENVIAR CÓDIGO SMS'}
                                    </button>
                                ) : (
                                    <>
                                        <input
                                            type="text"
                                            className="form-control form-control-lg text-center fw-bold mb-3"
                                            placeholder="000000"
                                            maxLength={6}
                                            style={{ fontSize: '2.5rem', letterSpacing: '12px', border: '3px solid ' + configLocal.colorPrimario, color: configLocal.colorPrimario }}
                                            value={codigoValidacion}
                                            onChange={e => setCodigoValidacion(e.target.value.replace(/\D/g, '').slice(0, 6))}
                                        />
                                        <p className="text-muted" style={{ fontSize: '0.75rem' }}>Código válido por 5 minutos</p>
                                    </>
                                )}
                                
                                {mensajeValidacion && (
                                    <div className={`alert alert-${mensajeValidacion.tipo} py-2 small text-center rounded-pill mb-3`}>
                                        {mensajeValidacion.texto}
                                    </div>
                                )}
                            </div>
                        )}
                        {(pasoForm === 2 || esperandoValidacion) && (<>
                        {motivoBloqueo && !esperandoValidacion && (
                            <div className="alert alert-warning py-2 small text-center rounded-3 mb-2">⚠️ {motivoBloqueo}</div>
                        )}
                        <button
                            className="btn btn-success w-100 rounded-pill py-3 fw-bold shadow-lg border-0"
                            style={{ backgroundColor: configLocal.colorPrimario }}
                            onClick={finalizarPedido}
                            disabled={loading || (!esperandoValidacion && !!motivoBloqueo)}
                        >
                            {loading ? t('carta', 'procesando') : (esperandoValidacion ? t('carta', 'validarCodigo') : `🚀 ${t('carta', 'enviarPedido')} $${totalFinal.toLocaleString('es-CL')}`)}
                        </button>
                        </>)}
                        <button className="btn btn-link w-100 text-muted mt-2" onClick={() => { setIsFormVisible(false); setEsperandoValidacion(false); }}>{t('carta', 'cerrar')}</button>
                    </div>
                </div>
            )}

            {pedidoActivo && estadoActual !== -1 && (
                <>
                    {datosCliente.verSeguimiento && (
                        <div style={{ position: 'fixed', inset: 0, backgroundColor: '#fff', zIndex: 99999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                        <div className={`display-1 mb-4 anim-${estadosConfig[estadoActual].anim}`}>{estadosConfig[estadoActual].icono}</div>
                            <h2 className="fw-bold text-center px-4 text-dark">{estadosConfig[estadoActual].texto}</h2>
                            <p className="text-muted">Orden #{pedidoActivo.display_id}</p>
                            <div className="w-75 bg-light rounded-pill mt-4 shadow-sm" style={{ height: '12px' }}>
                                <div style={{ width: `${((estadoActual + 1) / estadosConfig.length) * 100}%`, height: '100%', backgroundColor: configLocal.colorPrimario, transition: '1s', borderRadius: '10px' }}></div>
                            </div>

                            {/* 🛒 BOTÓN PARA VER DETALLE */}
                            {pedidoActivo.items && pedidoActivo.items.length > 0 && (
                                <>
                                    <button 
                                        className="btn btn-outline-secondary mt-4 rounded-pill px-4 py-2 fw-bold"
                                        onClick={() => setDatosCliente(prev => ({ ...prev, verDetalle: !prev.verDetalle }))}
                                    >
                                        {datosCliente.verDetalle ? t('carta', 'ocultarDetalle') : t('carta', 'verDetalle')}
                                    </button>
                                    {datosCliente.verDetalle && (
                                        <div className="w-75 mt-3 p-3 bg-white rounded-4 shadow-sm border" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                                            <h6 className="fw-bold text-muted mb-2 text-center border-bottom pb-2">TU PEDIDO</h6>
                                            {pedidoActivo.items.map((item, idx) => (
                                                <div key={idx} className="d-flex justify-content-between align-items-center py-1 border-bottom border-light">
                                                    <div className="text-start" style={{ flex: 1 }}>
                                                        <span className="fw-bold small">{item.cantidad}x {item.nombre}</span>
                                                        {item.variantes_detalles && (
                                                            <div className="text-muted" style={{ fontSize: '0.65rem' }}>{item.variantes_detalles}</div>
                                                        )}
                                                    </div>
                                                    <span className="fw-bold small ms-2">${Number(item.precio * item.cantidad).toLocaleString('es-CL')}</span>
                                                </div>
                                            ))}
                                            <div className="d-flex justify-content-between fw-bold mt-2 pt-2 border-top">
                                                <span>TOTAL</span>
                                                <span style={{ color: configLocal.colorPrimario }}>${Number(pedidoActivo.total).toLocaleString('es-CL')}</span>
                                            </div>
                                            {pedidoActivo.tipo_entrega_id && (
                                                <div className="text-center small text-muted mt-1">
                                                    {pedidoActivo.tipo_entrega_id === 2 ? '🛵 Delivery' : '🏪 Retiro en Local'}
                                                    {pedidoActivo.tipo_entrega_id === 2 && pedidoActivo.direccion && ` - ${pedidoActivo.direccion}`}
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </>
                            )}
                            {/* 🚩 Add-on Pedidos QR: pedir la cuenta desde el
                                seguimiento. Va aca ademas del boton flotante
                                porque despues de mandar el pedido el cliente
                                queda parado justo en esta pantalla, y es
                                exactamente cuando termina de comer y la pide. */}
                            {esModoMesa && usaPedidosQr && cuentaAbierta && (
                                <button
                                    className="btn mt-4 rounded-pill px-5 py-3 fw-bold shadow border-0"
                                    style={{ backgroundColor: cuentaYaPedida ? '#6c757d' : '#fd7e14', color: '#fff' }}
                                    onClick={pedirLaCuenta}
                                    disabled={pidiendoCuenta || cuentaYaPedida}
                                >
                                    {cuentaYaPedida
                                        ? '✓ Ya le avisamos al garzón'
                                        : (pidiendoCuenta ? 'Avisando al garzón...' : '💵 Pedir la cuenta')}
                                </button>
                            )}
                            {/* 🚩 En mesa, volver a la carta ES seguir pidiendo. Con
                                "Cerrar y ver menú" el cliente creia que su pedido ya
                                estaba cerrado y no se atrevia a pedir otro trago. */}
                            {esModoMesa && !cuentaCerrandose ? (
                                <button
                                    className="btn mt-4 rounded-pill px-5 py-3 fw-bold shadow border-0"
                                    style={{ backgroundColor: '#28a745', color: '#fff' }}
                                    onClick={() => setDatosCliente({ ...datosCliente, verSeguimiento: false, verDetalle: false })}
                                >
                                    ➕ Agregar algo más a mi pedido
                                </button>
                            ) : esModoMesa && cuentaCerrandose ? (
                                <div className="mt-4 px-4 text-center">
                                    <div className="p-3 rounded-4" style={{ backgroundColor: '#fff3cd', color: '#664d03', fontSize: '0.9rem' }}>
                                        Tu cuenta ya se está cerrando. Si quieres pedir algo más, avísale al garzón.
                                    </div>
                                    <button className="btn btn-dark mt-3 rounded-pill px-5" onClick={() => setDatosCliente({ ...datosCliente, verSeguimiento: false, verDetalle: false })}>{t('carta', 'cerrarVerMenu')}</button>
                                </div>
                            ) : (
                                <button className="btn btn-dark mt-4 rounded-pill px-5" onClick={() => setDatosCliente({ ...datosCliente, verSeguimiento: false, verDetalle: false })}>{t('carta', 'cerrarVerMenu')}</button>
                            )}
                            {estadoActual === 3 && <button className="btn btn-success mt-3 rounded-pill px-5 py-3 fw-bold shadow anim-pulse border-0" onClick={resetearParaNuevoPedido}>{t('carta', 'hacerNuevoPedido')}</button>}
                        </div>
                    )}
                    {!datosCliente.verSeguimiento && (
                        // 🚩 pointerEvents none en el contenedor: `fixed-bottom` ocupa
                        // TODO el ancho aunque la burbuja sea un circulo de 75px a la
                        // derecha, y con z-index 10000 se comia los clics de toda la
                        // franja de abajo. Con un pedido activo eso dejaba muerto el
                        // boton de "enviar a cocina" (z-index 5000) y la pastilla de
                        // la cuenta: el cliente tocaba y no pasaba nada.
                        <div className="fixed-bottom p-3 d-flex justify-content-end" style={{ zIndex: 10000, pointerEvents: 'none' }}>
                            <button className="btn shadow-lg rounded-circle d-flex align-items-center justify-content-center border-0"
                                style={{ backgroundColor: configLocal.colorPrimario, width: '75px', height: '75px', color: 'white', border: '3px solid white', pointerEvents: 'auto' }}
                                onClick={() => setDatosCliente({ ...datosCliente, verSeguimiento: true })}>
                                <div className="text-center"><div className="fs-2 mb-0 anim-pulse">{estadosConfig[estadoActual].icono}</div><div style={{ fontSize: '10px', fontWeight: '900' }}>PEDIDO</div></div>
                            </button>
                        </div>
                    )}
                </>
            )}

            {estadoActual === -1 && (
                <div className="modal-custom" style={{ zIndex: 100000, background: 'rgba(0,0,0,0.92)' }}>
                    <div className="modal-content-card text-center border-0" style={{ borderTop: '10px solid #dc3545' }}>
                        <div className="display-1 mb-4">🚫</div>
                        <h2 className="fw-bold text-danger mb-3">{t('carta', 'pedidoCancelado')}</h2>
                        <p className="text-muted mb-4">{t('carta', 'canceladoMsg')} <b>#{pedidoActivo ? pedidoActivo.display_id : ''}</b>.<br /><small>{t('carta', 'stockMsg')}</small></p>
                        <button className="btn btn-dark w-100 rounded-pill py-3 fw-bold shadow" onClick={resetearParaNuevoPedido}>{t('carta', 'entendidoVolver')}</button>
                    </div>
                </div>
            )}

            {pedidoActivo && estadoActual === -1 && !datosCliente.verSeguimiento && (
                <div className="fixed-bottom p-3 d-flex justify-content-end" style={{ zIndex: 10000 }}>
                    <button className="btn shadow-lg rounded-circle d-flex align-items-center justify-content-center border-0"
                        style={{ backgroundColor: '#dc3545', width: '75px', height: '75px', color: 'white', border: '3px solid white' }}
                        onClick={() => setEstadoActual(-1)}>
                        <div className="text-center"><div className="fs-2 mb-0 anim-pulse">❗</div><div style={{ fontSize: '10px', fontWeight: '900' }}>AVISO</div></div>
                    </button>
                </div>
            )}

            {productoParaVariantes && (
                <SelectorVariantesModal item={productoParaVariantes} onClose={() => setProductoParaVariantes(null)} onConfirm={(itemFinal) => { handleAdd(itemFinal); setProductoParaVariantes(null); setIsCarritoVisible(true); }} />
            )}
        </div>
    );
};

export default Pedidos;